//#region imports
import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ModalDirective } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { ReplaySubject, Subject, Subscription, forkJoin } from "rxjs";
import { BOItem } from "../../models/BOItem.model";
import { SellService } from '../../services/sell.service';
import { BOSell } from "../../models/BOSell.model";
import { BOSellDetail } from "../../models/BOSellDtail.model";
import { BOPerson } from "../../models/BOPerson.model";
import { PersonService } from "../../services/person.service";
import { ServiceTypeService } from "../../services/service-type.service";
import { PayTypeService } from '../../services/payType.service';
import { BOPayType } from "../../models/BOPayType.model";
import { BOPayTypeSellDetail } from "../../models/BOPayTypeSellDetail.model";
import { BOInvoiceType } from "../../models/BOInvoiceType.model";
import { InvoiceTypeService } from '../../services/invoiceType.service';
import { DialogConfirmService } from "../../services/dialog-confirm.service";
import { MatTable } from "@angular/material/table";
import { ChangeDetectorRef } from '@angular/core';
import { ChangeDetectionStrategy } from "@angular/core";  // import
import { Utilities } from "../../common/utilities";
//import { BOClinicHistoryObservations } from "../../models/BOClinicHistoryObservations.model";
import { BOSubServiceDetail } from '../../models/BOSubServiceDetail.model';
import { SubServiceDetailService } from '../../services/subServiceDetail.service';
import { SubServiceTypeService } from "../../services/subServiceType.service";
import { BOSubServiceType } from "../../models/BOSubServiceType.model";
import { ServiceGroupsService } from "../../services/serviceGroups.service";
import { IdTypeService } from "../../services/idType.service";
import { BOCompany } from "../../models/BOCompany.model";
import { CompanyService } from "../../services/company.service";
import { BOHeadQuarters } from "../../models/BOHeadQuarters.model";
import { HeadQuarterService } from "../../services/headQuarter.service";
import pdfMake from 'pdfmake/build/pdfmake';

import pdfFonts from 'pdfmake/build/vfs_fonts';
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
import { DatePipe } from "@angular/common";
import { GoogleDriveService } from "../../services/googleDriveService.service";
import { SpinnerService } from "../../services/spinner.service";
import { throwError, of } from 'rxjs';
import { delay, switchMap, takeUntil } from 'rxjs/operators';
import { MatSelectChange } from "@angular/material/select";

declare var gapi: any;


  const simulatedError$ = of(null).pipe(
    delay(3000),
    switchMap(() => throwError(() => new Error('Error simulado para pruebas')))
  );

//#endregion
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'sellModal',
    templateUrl: './sell.component.html',
    styleUrls: ['./sell.component.css'],
    providers: [DatePipe],
})

export class SellComponent implements OnDestroy, OnInit
{
  @Output() closeModal = new EventEmitter<void>(); // Evento para informar al componente principal que se cerró el modal
    @ViewChild('sellModal', { static: true }) modal: ModalDirective;
    @ViewChild('sellDetailTable') sellDetailTable:MatTable<BOSellDetail>;
    @ViewChild('payTypeSellDetailTable') payTypeSellDetailTable:MatTable<BOPayTypeSellDetail>;
    @ViewChild('createSubServiceModal') public createSubServiceModal: ModalDirective;
    @ViewChild('subServiceDetailTable') subServiceDetailTable: MatTable<BOSubServiceDetail>;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
    @Output() dataUpdated = new EventEmitter<number>();

    busy: Subscription | undefined;


    private _googleDriveService!: GoogleDriveService;

   // isModalVisible = false;
//#region variables-forms


    busyData$:Subscription;
    profesionalSelected:number;
    dataSource:BOSellDetail[]=[];
    dataSourcePayTypeSellDetailTable:BOPayTypeSellDetail[]=[];
    dataSourceSubServiceDetailTable:BOSubServiceDetail[]=[];
    displayedColumns: string[] = ['profesionalId', 'serviceTypeId', 'price', 'sellDetailIdTemp','acciones'];
    displayedColumnsPayTypeSellDetailTable: string[] = ['payTypeId', 'invoiceTypeName','numberPayTypeSellDetail', 'datePayTypeSellDetail','price', 'acciones'];
    displayedColumnsSubServiceDetailTable:string[]=['profesionalId', 'subServiceGroupId','serviceTypeId', 'subServiceTypeId', 'price','subServiceDetailIdTemp','acciones'];

    sellForm = this._formBuilder.group({

      documentNumber:         [{value:'', disabled:true}],
      dateSell:               ['', Validators.required],
      userName:               ['', Validators.required],
      userEmail:              ['', Validators.required],
      userId:                 ['', Validators.required],
      idTypeIdentification:   ['', Validators.required],

      invoiceTypeId:          [{value:'', disabled:true}],
      total:                  ['', Validators.required],
      observations:           [''],
      // url:                   [''],


    });

    sellDetailsForm= this._formBuilder.group({
      serviceGroupId:         ['', Validators.required],
      serviceTypeId:          ['', Validators.required],
      profesionalId:          ['', Validators.required],
      areaId:                 ['', Validators.required],
    })

    payTypeSellDetailForm= this._formBuilder.group({
        payTypeId:                    ['', Validators.required],
        invoiceTypeId:                ['', Validators.required],
        numberPayTypeSellDetail:      [''],
        datePayTypeSellDetail:        ['', Validators.required],
        totalPayTypeSellDetail:       [''],
        payTypeSellDetailBank:        [''],
        payTypeSellDetailObservations:[''],
        totalPayTypeSellDetailList:   [{ value: '', disabled: true }],
        counterPayTypeSellDetail:     [{ value: '', disabled: true }]
    })

    subServiceDetailForm= this._formBuilder.group({
      subServiceTypeId:               ['', Validators.required],
      profesionalId:                  [''],
      observations:                   [''],
    });

    profesionals                        :BOPerson           [] = [];
    profesionalsListShort               :BOPerson           [] = [];

    payTypeList                         :BOPayType          [] = [];
    serviceTypeList                     :BOItem             [] = [];
    serviceTypeListShort                :BOItem             [] = [];

    serviceGroupList                    :BOItem             [] = [];
    serviceGroupListShort               :BOItem             [] = [];




    idTypeList                          : BOItem            [] = [];
    headQuarterList                     : BOHeadQuarters    [] = [];


    subServiceTypeList                  :BOSubServiceType   [] = [];
    subServiceDetailList                :BOSubServiceDetail [] = [];
    subServicesByCurrentSdList          :BOSubServiceDetail [] = [];
    subServiceTypeListCopy              :BOSubServiceDetail [] = [];
    subServiceTypeListShort             :BOSubServiceType   [] = [];
    subServiceDetailIdTemp              :number=0;
    subServiceTypeIdTemp                :number=0;
    subServicesPricesTotal              :number=0;
    subServicesPricesBySellDetail       :number=0;



    invoiceTypeList                     :BOInvoiceType      [] = [];
    invoiceTypeListR                    :BOInvoiceType      [] = [];

    sellb                               :BOSell=new BOSell();
    sells                               :BOSell             [] = [];
    sellTotal                           :number;

    sellDetailsList                     :BOSellDetail       [] = [];
    sellDetailId                        :number=-1;
    sellDetailIdTemp                    :number=-1;
    sellDetailPricesTotal               :number=0;

    payTypeSellDetailsList              :BOPayTypeSellDetail[] = [];
    payTypePricesTotal                  :number=0;

    currentSell                         :BOSell;
    currentSellDetail                   :BOSellDetail= new BOSellDetail();
    currentPayTypeSellDetail            :BOPayTypeSellDetail;
    currentSubServiceDetail             :BOSubServiceDetail= new BOSubServiceDetail();


    positionCurrentSell                 :number=0;
    positionCurrentSellDetail           :number=0;
    positionCurrentPayTypeSellDetail    :number=0
    positionCurrentSubServiceDetail     :number=0


    sellIdTemp                          :number=0;
    sellDetailsIdTemp                   :number=0;
    payTypeSellDetailsIdTemp            :number=0;

    showSellSavePersonalDataBtn         :boolean=false;
    showSellDetailSaveBtn               :boolean=false;

    showSellDetailNav                   :boolean=false;
    showLastSellDetail                  :boolean=false;
    showPayTypeSellDetailNav            :boolean=false;
    showLastPayTypeSellDetail           :boolean=false;

    showSubServiceDetailNav             :boolean=false;
    showLastSubServiceDetail            :boolean=false;

    showSaveSellButton                  :boolean=true;
    showSavePtBtn                       :boolean=true;
    showSaveSbvcBtn                     :boolean=true;


    showEmptySbSvNav                   :boolean=true;
    showEmptySellDetailNav             :boolean=true;

    origen                              :number=0;

    resultRemoveSellDetail              :boolean=false;
    resultRemovePayTypeSellDetail       :boolean=false;
    resultRemoveSubServiceDetail        :boolean=false;

    company                             : BOCompany;

    units                               :string[]=[];
    tenToSixteen                        :string[]=[];
    tens                                :string[]=[];

    theBlob:Blob= new Blob();
    theBlobFileName:string='';

    utilities: Utilities= new Utilities();

    isSaving:boolean=false;
    isLoading:boolean=false;
    errorMessage: string | null = null;
    searchingSubService: boolean = false;


    filteredSubServicesShort              : ReplaySubject<BOSubServiceType[]> = new ReplaySubject<BOSubServiceType[]>(1);
    subServiceFilterCtrl                   : FormControl = new FormControl();

        protected _onDestroy = new Subject<void>();


//#endregion variables-forms

    constructor(public   toastr            : ToastrService,
                private _formBuilder       : FormBuilder,
                private _sellService       : SellService,
                private _personService     : PersonService,
                private _serviceTypeService: ServiceTypeService,
                private _servicePayType    : PayTypeService,
                private _serviceInvoiceType: InvoiceTypeService,
                private _dialogConfirm     : DialogConfirmService,
                private _subServiceType    : SubServiceTypeService,
                private _subServiceDetail  : SubServiceDetailService,
                private _serviceGroupService: ServiceGroupsService,
                private _changeDetectorRef : ChangeDetectorRef,
                private _idTypeService     : IdTypeService,
                private _companyService    : CompanyService,
                private _headQuarterService: HeadQuarterService,
                private datePipe           : DatePipe,
                private _spinnerService    : SpinnerService,


              ) { }




// closeFromMain() {
//    this.closeModal.emit(); // Notifica al componente principal que el modal se cerró
// }
    async ngOnInit(): Promise< void>
    {
      this.units = ['', 'un', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve'];
      this.tenToSixteen = ['diez', 'once', 'doce', 'trece', 'catorce', 'quince', 'dieciséis'];
      this.tens = ['treinta', 'cuarenta', 'cincuenta', 'sesenta', 'setenta', 'ochenta', 'noventa'];

      this.currentSellDetail.subServicesDetails=[];


    this.subServiceFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe((value) => {
            console.log('🔔 [valueChanges] Cambio detectado en subServiceFilterCtrl, valor:', value);
            this.filterSubServiceShort();
        });

    }

    async dataLoad(sellbId: number, saveSellActivatorBtn?:number): Promise<void> {
      this.invoiceTypeListR = [];

      this._spinnerService.show(); // Mostrar el spinner antes de iniciar la carga

      this.busyData$ = forkJoin({
        resultProfesionals: this._personService.getProfesionals(),
        resultServiceType: this._serviceTypeService.getAll(),
        resultServicePayType: this._servicePayType.getAll(),
        resultServiceInvoiceType: this._serviceInvoiceType.getAll(),
        resultServiceSubServiceTypeList: this._subServiceType.getAll(),
        resultSubServiceDetailList: this._subServiceDetail.getAll(),
        resultServiceGroupList: this._serviceGroupService.getAll(),
        resultIdType: this._idTypeService.getAll(),
        resultCompany: this._companyService.getCompany(),
        resultHeadquarter: this._headQuarterService.getHeadQuarters(),
        resultSell: this._sellService.getSell(sellbId)
      }).subscribe({
        next: ({
          resultProfesionals,
          resultServiceType,
          resultServicePayType,
          resultServiceInvoiceType,
          resultServiceSubServiceTypeList,
          resultServiceGroupList,
          resultIdType,
          resultCompany,
          resultHeadquarter,
          resultSell
        }) => {
          // Asignar los datos a las propiedades correspondientes
          this.profesionals = resultProfesionals;
          this.profesionalsListShort = resultProfesionals;

          this.serviceTypeList = resultServiceType;
          this.payTypeList = resultServicePayType;
          this.invoiceTypeList = resultServiceInvoiceType;
          this.subServiceTypeList = resultServiceSubServiceTypeList;
          this.serviceGroupList = resultServiceGroupList;
          this.serviceGroupListShort = resultServiceGroupList;
          this.idTypeList = resultIdType;
          this.company = resultCompany;
          this.headQuarterList = resultHeadquarter;
          this.sellb = resultSell;

          this.subServiceTypeListShort = resultServiceSubServiceTypeList;

          // Filtrar la lista de tipos de factura
          this.invoiceTypeList.forEach((i) => {
            if (i.id != 3 && i.id != 4) {
              this.invoiceTypeListR.push(i);
            }
          });

          // Cargar datos adicionales
          this.loadSellData(saveSellActivatorBtn);
        },
        error: (err) => {
          console.error('Error al cargar los datos: ', err);
          this._spinnerService.hide(); // Asegurarse de ocultar el spinner en caso de error
        },
        complete: () => {
          console.log('Carga de datos completa');
          //this._spinnerService.hide(); // Ocultar el spinner al finalizar
        }
      });
    }


    loadSellData(saveSellActivatorBtn:number)
    {
      //          this._spinnerService.show();
      this.showSellDetailSaveBtn=true;
      this.showSaveSbvcBtn=true;
      this.showSavePtBtn=true;
      this.showSellSavePersonalDataBtn=true;
      this.showSaveSellButton=true;
      this._changeDetectorRef.detectChanges();

      if(saveSellActivatorBtn !==undefined)
      {
        if(saveSellActivatorBtn ==3) this.showSaveSellButton=false;
      }

      if(this.sellb)
      {


            this.positionCurrentSell =0;
            this.positionCurrentSellDetail=0;
            this.positionCurrentPayTypeSellDetail=0;
            this.currentSell=this.sellb;
            this.sellDetailsList=this.currentSell.sellDetails;

            this.sellDetailsList.forEach(slld=>
            {
              this.sellDetailPricesTotal+=slld.price;
              slld.sellDetailIdTemp=this.sellDetailsIdTemp;

              slld.itemSaved=true;

              this.sellDetailsIdTemp+=1;

                slld.subServicesDetails.forEach(subsvc=>{
                  this.subServicesPricesTotal+=subsvc.price;
                  subsvc.subServiceDetailIdTemp=this.subServiceDetailIdTemp;
                  subsvc.sellDetailIdTemp=slld.sellDetailIdTemp;
                  this.subServiceDetailList.push(subsvc);
                  this.subServiceDetailIdTemp+=1;
                })
            })
          //
            this.currentSellDetail=this.sellDetailsList[0];
            this.subServicesByCurrentSdList=this.currentSellDetail.subServicesDetails;
      //llena los datos de serviceTypeListShort con base en el groupId
            let svcGroupId=this.currentSellDetail.serviceGroupId;
            let svcGroupIdString=this.convertNumberToString(svcGroupId);
            this.serviceTypeListShort=Utilities.getServicesxGroupId(svcGroupIdString, this.serviceTypeList);

            this.profesionalsListShort =Utilities.getProfessionalssByAreaId(this.currentSellDetail.areaId, this.profesionals);
            this.serviceGroupListShort =Utilities.getGroupsByAreaId(this.currentSellDetail.areaId, this.serviceGroupList);


            this.currentSubServiceDetail=this.subServicesByCurrentSdList[0];
            this.positionCurrentSubServiceDetail=0;

            this.subServiceDetailForm.patchValue({
              subServiceTypeId:this.subServicesByCurrentSdList[0].subServiceTypeId,
              profesionalId:this.subServicesByCurrentSdList[0].profesionalId,
              observations:this.subServicesByCurrentSdList[0].observations,

            })

            this.payTypeSellDetailsList=this.currentSell.payTypeSellDetails;
      //obtiene el total de los payTypes actuales
            this.payTypeSellDetailsList.forEach(ptd=>{
              this.payTypePricesTotal+=ptd.price;
            })
      //  identificaar la currenSellDetail

            this.currentPayTypeSellDetail=this.payTypeSellDetailsList[0];

            this.sellForm.patchValue({
              documentNumber:this.currentSell.documentNumber,
              invoiceTypeId:this.currentSell.invoiceTypeId,
              total:this.currentSell.total,
              dateSell:this.currentSell.dateSell,
              userId:this.currentSell.userIdString,
              userName:this.currentSell.userName,
              userEmail:this.currentSell.userEmail,
              observations:this.currentSell.observations,
              //url:this.currentSell.url,
              idTypeIdentification:this.currentSell.idTypeIdentification,
              //observations:this.currentSell.observations,
            });

            this.payTypeSellDetailsList.forEach(p=>{
            p.payTypeIdTemp=this.payTypeSellDetailsIdTemp;
              this.payTypeSellDetailsIdTemp+=1;
            })

            this.sellDetailsForm.patchValue({
              serviceTypeId:this.currentSellDetail.serviceTypeId,
              serviceGroupId:this.currentSellDetail.serviceGroupId,
              profesionalId:this.currentSellDetail.profesionalId,
              // price:this.currentSellDetail.price,
              areaId: this.currentSellDetail.areaId,

            });


            this.payTypeSellDetailForm.patchValue({
              payTypeId:this.currentPayTypeSellDetail.payTypeId,
              invoiceTypeId:this.currentPayTypeSellDetail.invoiceTypeId,
              numberPayTypeSellDetail:this.currentPayTypeSellDetail.numberPayTypeSellDetail,
              datePayTypeSellDetail:this.currentPayTypeSellDetail.datePayTypeSellDetail,
              totalPayTypeSellDetail:this.currentPayTypeSellDetail.price,
              counterPayTypeSellDetail:1,
              totalPayTypeSellDetailList:this.payTypeSellDetailsList.length,
              payTypeSellDetailBank:this.currentPayTypeSellDetail.payTypeSellDetailBank,
              payTypeSellDetailObservations:this.currentPayTypeSellDetail.payTypeSellDetailObservations,
            });

            this.showSellDetailNav=true;
            this.showPayTypeSellDetailNav=true;

            this.modal.config = { backdrop: "static", keyboard: false };

            this._spinnerService.hide();

            this.modal.show();
       }
       else
       {
              this._spinnerService.hide();
              this.toastr.error('Error', 'Se ha producido error en la búsqueda del registro')
       }
        console.log('  Al salir de Edit->loadSellData, this.showSaveSellButton es:',  this.showSaveSellButton);
      //this._spinnerService.hide();

    }

    async uploadPdfToGoogleDrive(sellId: number, blob:Blob, nameFile:string, area:number): Promise<void>
    {

      console.log('Entra a uploadPdfToGoogleDrive');
      try
      {

        await this._googleDriveService.signIn(area)
        .then(()=>{
          //this.toastr.success('Éxito', 'signIn inicializado y firmado');
          console.log('Éxito en signIn en inicialización')
        }).catch(error=>{
         // this.toastr.error('Fallo', 'No logró inicializar en signIn');
         console.log('Fallo en signIn en inicialización')

        }); // Autentica al usuario

        if (blob) {

          await this._googleDriveService.uploadFile(blob, nameFile)
          .then((fileId) => {
          const publicUrl = `https://drive.google.com/file/d/${fileId}/view`;
          console.log('URL pública:', publicUrl);
          // Puedes abrir el archivo en el navegador
          window.open(publicUrl, '_blank');

          this._sellService.saveUrl(sellId, publicUrl).subscribe(x=>{
            if(x==1)
            {
              this.toastr.success('url exitosa','Se guardó la url del pdf');
            }
          });




        })
        .catch((error) => {
          console.error('Error al subir el archivo:', error);
        });

          this.toastr.success('Exito','Se guardó el recibo en Drive');

        }
      }
      catch (error)
      {
        console.error('Error:', error);
        this.toastr.error('Fallo','No se guardó el recibo en Drive');
      }
    }

//#region getName

    getProfesionalName(idProfessional:number):string
    {
      let name:string="";

      this.profesionals.forEach(p=>{
        if(p.id==idProfessional)
        {
          if(p.secondName.length<=0) p.secondName='';
          else p.secondName=p.secondName+' ';
          name=p.firstName +' '+p.secondName+ p.firtsSurName;
          name=name.trim();
        }
      });
      return name;
    }

    getServiceName(idService:number):string
    {
      let name:string="";

      this.serviceTypeList.forEach(s=>{
        if(s.id==idService)
        {
          name=s.name;
        }
      });
      return name;
    }

    getPayTypeName(idPayType:number):string
    {
      let name:string="";

      this.payTypeList.forEach(p=>{
        if(p.id==idPayType)
        {
          name=p.name;
        }
      });
      return name;
    }

    getInvoicePayTypeName(idInvoicePayType:number):string
    {
      let name:string="";

      this.invoiceTypeList.forEach(p=>{
        if(p.id==idInvoicePayType)
        {
          name=p.name;
        }
      });
      return name;
    }

    getSubServiceTypeName(idSubServiceType:number):string
    {
      let name:string="";

      this.subServiceTypeList.forEach(p=>{
        if(p.id==idSubServiceType)
        {
          name=p.name;
        }
      });
      return name;
    }

    getGroupName(idGroup:number):string
    {
      let name:string="";

      this.serviceGroupList.forEach(p=>{
        if(p.id==idGroup)
        {
          name=p.name;
        }
      });
      return name;
    }

    getNameFromProfesional(person:BOPerson):string
    {
     let result='';
      let sname=person.secondName;
      let sn='';
      sname.length>0?sn=sname:sn='';
      let name=person.firstName +' '+sn;

      let ssname= person.secondSurName;
      let secondsn='';
      ssname.length>0?secondsn=ssname: secondsn='';
      let lastname=person.firtsSurName +' '+secondsn;
      result= name+' '+lastname;
      return result;
}
//#endregion getName

//#region Sell

    openSellModal(boSell:BOSell,  origen: number): void
    {
      console.log('Entra a openSellModal, boSell es:', boSell, ' origen es:', origen, "boSell.id es: ", boSell.id);
      this.sellDetailPricesTotal=0;
      this.payTypePricesTotal=0;

    this.dataLoadToOpenSellModal(boSell,origen);
    }

    dataLoadToOpenSellModal (boSell:BOSell,  origen: number):void
    {
      this._spinnerService.show();
      this.invoiceTypeListR=[];
      this.busyData$ = forkJoin
      (
        {
        resultProfesionals: this._personService.getProfesionals(),
        resultServiceType: this._serviceTypeService.getAll(),
        resultServicePayType: this._servicePayType.getAll(),
        resultServiceInvoiceType:this._serviceInvoiceType.getAll(),
        resultServiceSubServiceTypeList: this._subServiceType.getAll(),
        resultSubServiceDetailList:this._subServiceDetail.getAll(),
        resultServiceGroupList:this._serviceGroupService.getAll(),
        resultCompany: this._companyService.getCompany(),
        resultHeadquarter: this._headQuarterService.getHeadQuarters(),
        resultIdType: this._idTypeService.getAll(),

        }
      ).subscribe
        ((
            {
              resultProfesionals,
              resultServiceType,
              resultServicePayType,
              resultServiceInvoiceType,
              resultServiceSubServiceTypeList,
              resultServiceGroupList,
              resultCompany,
              resultHeadquarter,
              resultIdType,
            }
          )=>
             {
                this.profesionals = resultProfesionals;
                this.profesionalsListShort = resultProfesionals;

                this.serviceTypeList = resultServiceType;
                this.payTypeList=resultServicePayType;
                this.invoiceTypeList=resultServiceInvoiceType;
                this.subServiceTypeList= resultServiceSubServiceTypeList;
                this.serviceGroupList=resultServiceGroupList;
                this.serviceGroupListShort =resultServiceGroupList;

                this.company = resultCompany;
                this.headQuarterList = resultHeadquarter;
                this.idTypeList=resultIdType;

                this.invoiceTypeList.forEach(i=>{
                  if(i.id !=3 && i.id !=4)
                    {
                      this.invoiceTypeListR.push(i);
                    }
                });
                this._spinnerService.hide();
                this.loadBodyOpenSellModal(boSell, origen);

             }
        )
    }


    loadBodyOpenSellModal(boSell:BOSell,  origen:number):void
    {
      console.log('Entra a loadBodyOpenSellModal, boSelles:', boSell);
      this.positionCurrentSell =0;
      this.positionCurrentSellDetail=0;
      this.positionCurrentPayTypeSellDetail =0;

      this.sells=[];
      this.sellDetailsList=boSell.sellDetails;
      console.log("carga this.sellDetailsList:", this.sellDetailsList);
      this.sellb=new BOSell();
      this.origen=origen;

      this.sellDetailsIdTemp         =0;
      this.payTypeSellDetailsIdTemp  =0;
      this.subServiceDetailIdTemp    =0;

      this.serviceTypeListShort=[];

      if(origen==1) //viene de ch
      {
        console.log("Entra a origen1 en loadBodyOpenSellModal. boSell es: ", boSell);
        this.sellb=boSell;
        this.sellb.documentNumber='';
        this.sellb.observations='';
        this.sellb.payTypeSellDetails=[];
        this.currentSell=this.sellb;
        this.fillSell();
        this.currentSellDetail=this.sellDetailsList[0];
        this.currentSellDetail.sellDetailIdTemp=100;
        this.currentSellDetail.itemSaved=false;
        this.currentSellDetail.areaId=this.sellb.areaId;
        //
        this.currentSellDetail.subServicesDetails=[];

        this.sellDetailsIdTemp=1;

        //llena los datos de serviceTypeListShort con base en el groupId
        let svcGroupId=this.currentSellDetail.serviceGroupId;
        let svcGroupIdString=this.convertNumberToString(svcGroupId);
        this.serviceTypeListShort=Utilities.getServicesxGroupId(svcGroupIdString, this.serviceTypeList);

        this.profesionalsListShort =Utilities.getProfessionalssByAreaId(this.sellb.areaId, this.profesionals);
        this.serviceGroupListShort=Utilities.getGroupsByAreaId(this.sellb.areaId, this.serviceGroupList);
        //NEW


        this.fillSellDetails();
        this.onOptionServiceTypeSelected(this.currentSellDetail.serviceTypeId);

       // this.sellDetailPricesTotal= this.currentSellDetail.price;
        if(this.sellb.payTypeSellDetails.length>0)
        {
          this.currentPayTypeSellDetail=this.payTypeSellDetailsList[0];
        }
        else this.currentPayTypeSellDetail=null;

        this.fillPayTypeSellDetails();
        this.showSellDetailSaveBtn=true;
        this.showSaveSbvcBtn=true;
        this.showSavePtBtn=true;
        this.showSellSavePersonalDataBtn=true;
        this.showSaveSellButton=true;
        this._changeDetectorRef.detectChanges();

        this.showSellDetailNav=true;
        this.showPayTypeSellDetailNav=false;

      }
      if(origen==2) //viene de dashboard o de crearFactura en invoices-->vacía
      {
        this.sellb=boSell;
        this.positionCurrentSell =0;
        this.positionCurrentSellDetail=0;
        this.positionCurrentPayTypeSellDetail =0;
        this.sellb.total=0;
        this.sellb.payTypeSellDetails=[];
        this.sellb.sellDetails=[];
        this.sellb.observations='';
        this.currentSell=this.sellb;
        this.fillSell();
        this.fillPayTypeSellDetailsEmpty();

        this.showSellDetailSaveBtn=true;
        this.showSaveSbvcBtn=true;
        this.showSavePtBtn=true;
        this.showSellSavePersonalDataBtn=true;
        this.showSaveSellButton=true;
        this._changeDetectorRef.detectChanges();
      }


      this.modal.config = { backdrop: "static", keyboard: false };
      this.modal.show();
      console.log('Al salir de loadBodyOpenSellModal, this.showSellDetailSaveBtn es:', this.showSellDetailSaveBtn);



    }

    async openSellModalEdit(sellId?:number, saveSellActivatorBtn?:number): Promise<void>
    {
      //this.isLoading=true;
      this.sellDetailsIdTemp         =800;
      this.payTypeSellDetailsIdTemp  =800;
      this.subServiceDetailIdTemp    =800;

      this.serviceTypeListShort=[];
      this.subServiceDetailList=[];
      this.sellDetailPricesTotal=0;
      this.payTypePricesTotal=0;

      this.subServicesPricesTotal=0;
      this.sellb=new BOSell();

      await this.dataLoad(sellId, saveSellActivatorBtn);

    }

    navNextSell(){

      if(this.positionCurrentSell >=0 && this.positionCurrentSell <= this.sells.length-2)
      {
        this.currentSell=this.sells[this.positionCurrentSell+1];
        this.positionCurrentSell+=1;

      }

      this.fillSell();

    }

    navBackSell(){

      if(this.positionCurrentSell > 0)
        {
          this.positionCurrentSell-=1;
          this.currentSell=this.sells[this.positionCurrentSell];
        }
        this.fillSell();

    }

saveSell()
{
  // ✅ PREVENCIÓN DE MÚLTIPLES CLICKS
  if (this.isSaving) {
    this.toastr.warning('Operación en curso', 'Por favor espere a que se complete el guardado');
    return;
  }

  let totalPayTypeSellDetails: number = 0;
  let totalSellDetails: number = 0;

  this.sellb.userName = this.sellb.userName!.toUpperCase();

  // Validación de datos requeridos
  if (this.sellDetailsList.length <= 0 || this.payTypeSellDetailsList.length <= 0 || this.subServicesByCurrentSdList.length <= 0) {
    this.toastr.error('Faltan Datos', 'Tipo de Servicio, Tipo de Pago o Subservicio necesitan llenar datos');
    return;
  }

  try {
    // Limpia los id de sellDetails
    this.sellDetailsList.forEach(x => {
      x.id = undefined;
    });

    let totalSiigo: number = 0;
    let totalCore: number = 0;

    // Procesa payTypeSellDetails
    this.payTypeSellDetailsList.forEach(p => {
      p.id = undefined;
      totalPayTypeSellDetails += parseInt(p.price.toString());
      // Identifica números de siigo y core
      p.invoiceTypeId == 1 ? totalSiigo += 1 : totalCore += 1;
    });

    console.log('Después de calcular, totalPayTypeSellDetails es:', totalPayTypeSellDetails);

    // Determina el tipo de factura
    let invoiceTypeIdTemp: number = 0;

    if (this.payTypeSellDetailsList.length == 1) {
      invoiceTypeIdTemp = this.payTypeSellDetailsList[0].invoiceTypeId == 1 ? 1 : 2;
    } else {
      if (totalCore == 0) invoiceTypeIdTemp = 1;
      if (totalSiigo == 0) invoiceTypeIdTemp = 2;
      if (totalSiigo >= 1 && totalCore >= 1) invoiceTypeIdTemp = 3;
    }

    console.log('Llega a this.sellDetailsList');

    // Mapea los subservicios a los detalles de venta
    this.sellDetailsList.forEach(sd => {
      sd.subServicesDetails = [];

      this.subServicesByCurrentSdList.forEach(sb => {
        if (sb.sellDetailIdTemp == sd.sellDetailIdTemp) {
          sb.id = undefined;
          sd.subServicesDetails.push(sb);
        }
      });
    });

    // Asigna valores al objeto sellb
    this.sellb.invoiceTypeId = invoiceTypeIdTemp;
    this.sellb.areaId = parseInt(this.sellDetailsForm.get('areaId').value);
    this.sellb.sellDetails = this.sellDetailsList;
    this.sellb.payTypeSellDetails = this.payTypeSellDetailsList;
    this.sellb.sellDetails[0].price = parseInt(this.sellForm.get('total').value);
    this.sellb.sellDetails[0].subServicesDetails[0].price = totalPayTypeSellDetails;

    // ✅ MARCA COMO GUARDANDO
    this.isSaving = true;
    this.errorMessage = null;

    // ✅ ELIMINA EL DELAY(2000) - ERA LA CAUSA PRINCIPAL
    this.busy = this._sellService.saveSell(this.sellb)
      .subscribe({
        next: async (x) => {
          if (x) {
            this.toastr.success('Éxito en guardar', 'Se ha guardado el recibo', { timeOut: 600 });
            this.close();
            this.dataUpdated.emit(x.id);
            this.showSellDetailSaveBtn = true;
            this.showSaveSbvcBtn = true;
            this.showSavePtBtn = true;
            this.showSellSavePersonalDataBtn = true;
            this.showSaveSellButton = true;
            this._changeDetectorRef.detectChanges();
          }
        },
        error: (err) => {
          this.isSaving = false;
          this._changeDetectorRef.detectChanges();
          this.errorMessage = "Error al guardar el recibo";
          this.toastr.error('Error al guardar el recibo', 'Error', { timeOut: 1500 });
          console.error('Error en saveSell:', err);
        },
        complete: () => {
          this.isSaving = false;
          console.log('Operación saveSell completada');
          this._changeDetectorRef.detectChanges();
        }
      });

  } catch (error) {
    this.isSaving = false;
    this.errorMessage = "Error al procesar los datos";
    this.toastr.error('Error al procesar los datos', 'Error', { timeOut: 1500 });
    console.error('Error en saveSell:', error);
    this._changeDetectorRef.detectChanges();
  }
}


  saveSellPersonalData()
  {

    console.log('Entra a saveSellPersonalData');
    console.log('this.payTypeSellDetailsList es:', this.payTypeSellDetailsList);
    console.log('this.sellDetailsList es:', this.sellDetailsList);
    console.log('this.subServicesByCurrentSdList es:', this.subServicesByCurrentSdList);

    this.currentSell=new BOSell();
    let userNameTemp:string= this.sellForm.get('userName')!.value;
    userNameTemp=userNameTemp.toUpperCase();
    //prepare data
    //this.sellb.userId=this.sellForm.get('userId').value;
    this.sellb.userIdString=this.sellForm.get('userId')!.value;


    this.sellb.userName=userNameTemp;
    this.sellb.userEmail=this.sellForm.get('userEmail')!.value;
    this.sellb.dateSell=new Date(this.sellForm.get('dateSell')!.value);
    this.sellb.invoiceTypeId=0;
    this.sellb.idTypeIdentification=parseInt(this.sellForm.get('idTypeIdentification')!.value);
    this.sellb.total=parseInt(this.sellForm.get('total')!.value);
    this.sellb.observations=this.sellForm.get('observations')!.value;
    // this.sellb.url=this.sellForm.get('url').value;

    this.sellb.sellIdTemp=5;
    //
    this.currentSell=this.sellb;
    this.showSellSavePersonalDataBtn?this.showSellSavePersonalDataBtn=false:this.showSellSavePersonalDataBtn=true;
    this.fillSell();
    this.sellDetailsList=[];
    console.log('Al salir de saveSellPersonal this.sellDetailsList es:', this.sellDetailsList);
  }

  saveSellMedicalGeneralConsultant()
  {
    //Guarda datos personales






  }

//#endregion openSell

//#region sellDetail
    saveSellDetail():void
    {

      console.log('Entra a  saveSellDetail');
      let pos=this.positionCurrentSellDetail;

      console.log('this.sellDetailsList es:',this.sellDetailsList);
      console.log('post y  this.positionCurrentSellDetail es:', pos);

      try
      {
       if(this.origen==0)//origen is 1 ch
       {
          if(this.sellDetailsList.length>0)
          {
            this.sellDetailGreaterThanZero();
          }
          else
          {
            this.sellDetailSmallerOrEqualZero();
          }

       }

        if(this.origen==1)//origen is 1 ch
        {
          console.log('Viene de CrearMP x primera vez');

          if(this.sellDetailsList.length>0)
          {
            this.sellDetailGreaterThanZero();
          }
          else
          {
            this.sellDetailSmallerOrEqualZero();
          }

        }

        if(this.origen==2)
        {
          console.log('Viene de CrearAdicional');

          if(this.sellDetailsList.length>0)
          {
                ///verificamos si idTemp ==undefinde
                if(this.sellDetailsList[0].sellDetailIdTemp==undefined){
                  this.sellDetailsList[0].sellDetailIdTemp=this.sellDetailsIdTemp;
                this.sellDetailsIdTemp+=1;
                }

              this. sellDetailGreaterThanZero();

          }// end  if origen==2 y this.sellDetailsList.length>0
          else
          {
            this.sellDetailSmallerOrEqualZero();
          }

        }

        if(this.origen==3) //edita
        {

          if(this.sellDetailsList.length>0)
          {

                this. sellDetailGreaterThanZero();

          }// end  if origen== y this.sellDetailsList.length>0
            else
          {

              this.sellDetailSmallerOrEqualZero();
          }
        }


         //this.toastr.success('Éxito en guardar','Se ha guardado el servicio');
      }
      catch (error)
      {
         this.toastr.error('Fallo en guardar','No se ha guardado el servicio')
      }

    }

    sellDetailGreaterThanZero():void
    {
      console.log('Entra a  sellDetailGreaterThanZero');
        let pos=this.positionCurrentSellDetail;

        console.log('this.sellDetailsList es:',this.sellDetailsList);
        console.log('post y  this.positionCurrentSellDetail es:', pos);

        let verifyTemp:number=null;

        if(this.sellDetailsList[pos] !==null &&  this.sellDetailsList[pos] !== undefined)
        {
          this.sellDetailEdit();
        }
        else
        {
          //console.log('entra a sellDetailGreaterThanZero');

          verifyTemp=-1;
          let bosd: BOSellDetail= new BOSellDetail();
          bosd.profesionalId=this.sellDetailsForm.get('profesionalId').value;
          bosd.serviceTypeId=this.sellDetailsForm.get('serviceTypeId').value;
          bosd.serviceGroupId=this.sellDetailsForm.get('serviceGroupId').value;

          //bosd.price=parseFloat(this.sellDetailsForm.get('price').value);
          bosd.price=this.sellb.total;
          bosd.sellDetailIdTemp=this.sellDetailsIdTemp;

          bosd.itemSaved=true;
         // bosd.areaId=this.sellb.areaId;
         bosd.areaId=parseInt(this.sellDetailsForm.get('areaId').value);
          this.sellb.areaId=parseInt(this.sellDetailsForm.get('areaId').value);


          this.sellDetailsList.push(bosd);
          this.sellDetailPricesTotal+=bosd.price;

          let position=this.sellDetailsList.length-1;
          this.currentSellDetail=this.sellDetailsList[position];
          this.positionCurrentSellDetail=position;

          this.fillSellDetails();
         // this.sellDetailTable.renderRows();
          this.showSellDetailSaveBtn==true? this.showSellDetailSaveBtn=false: this.showSellDetailSaveBtn=true;
                this._changeDetectorRef.detectChanges();

          this.showSellDetailNav=true;
          this.showLastSellDetail=false;
          this.sellDetailsIdTemp+=1;
         // this.toastr.success('Éxito en guardar','Svc guardado en Greather than Zero');
          console.log('Al salir de sellDetailGreaterThanZero,  this.currentSellDetail es:', this.currentSellDetail);

        }

    }

    sellDetailSmallerOrEqualZero():void
    {
      console.log('Entra a   sellDetailSmallerOrEqualZero');

      let bosd: BOSellDetail= new BOSellDetail();
      bosd.profesionalId=this.sellDetailsForm.get('profesionalId').value;
      bosd.serviceTypeId=this.sellDetailsForm.get('serviceTypeId').value;
      bosd.serviceGroupId=this.sellDetailsForm.get('serviceGroupId').value;
     // bosd.price=parseFloat(this.sellDetailsForm.get('price').value);
      bosd.price=this.sellb.total;

      bosd.sellDetailIdTemp=this.sellDetailsIdTemp;

      bosd.itemSaved=true;
      //bosd.areaId=this.sellb.areaId;
      bosd.areaId=parseInt(this.sellDetailsForm.get('areaId').value);
      this.sellb.areaId=parseInt(this.sellDetailsForm.get('areaId').value);

      this.sellDetailsList.push(bosd);
      this.sellDetailPricesTotal+=bosd.price;
      let position=this.sellDetailsList.length-1;
      this.currentSellDetail=this.sellDetailsList[position];
      this.positionCurrentSellDetail=position;

      this.fillSellDetails();
      this.showSellDetailSaveBtn==true? this.showSellDetailSaveBtn=false: this.showSellDetailSaveBtn=true;
      this._changeDetectorRef.detectChanges();
      this.showSellDetailNav=true;
      this.sellDetailsIdTemp+=1;
      //this.toastr.success('Éxito', 'Se guardó con éxito el servicio');
    }


    launchRemoveSellDetailById(id:number):void{
      this.removeSellDetailById(id);
    }

    removeSellDetailById(id:number):void
    {
      this.resultRemoveSellDetail=false;
      let confirm:boolean=false;

      this._dialogConfirm.openConfirmDialog('¿Está seguro que quiere borrar este elemento?')
      .afterClosed().subscribe(res=>{
        confirm=res;

        if(confirm)
        {
            const index=this.sellDetailsList.findIndex(item=>item.sellDetailIdTemp==id);
            let priceTemp:number=this.sellDetailsList[index].price;

            if(index==0 && this.sellDetailsList.length==1)
            {
                  let priceTemp:number=this.sellDetailsList[index].price;
                  this.sellDetailsList.splice(index,1);
                  this.sellDetailPricesTotal-=priceTemp;
                  //Actualiza el total de la factura
                  //this.currentSell.total-=priceTemp;

                  // this.sellForm.patchValue({
                  //   total:this.currentSell.total});

                   this.resultRemoveSellDetail=true;
                 //  this.currentSellDetail=null;

                   this.currentSellDetail=new BOSellDetail();
                   this.currentSellDetail.sellDetailIdTemp=0;
                   this.sellDetailsForm.reset();
                 //  this.positionCurrentSellDetail=null;
                   this.positionCurrentSellDetail=0;


                   this.showSellDetailNav=false;
                   this.showEmptySellDetailNav=true;
            }

            if(index==0 && this.sellDetailsList.length>1)
            {
                    this.sellDetailsList.splice(index,1);
                    this.sellDetailPricesTotal-=priceTemp;

                     //Actualiza el valor total de la factura
                    //this.currentSell.total-=priceTemp;

                    //this.sellForm.patchValue({
                     // total:this.currentSell.total});

                    this.resultRemoveSellDetail=true;
                    this.currentSellDetail= this.sellDetailsList[0];
                    this.positionCurrentSellDetail=0;

                    this.sellDetailsForm.patchValue({
                      profesionalId:this.currentSellDetail.profesionalId,
                      serviceTypeId: this.currentSellDetail.serviceTypeId,
                      price:this.currentSellDetail.price,
                      counterSellDetail:this.positionCurrentSellDetail+1,
                      totalSellDetailList:this.sellDetailsList.length
                    })

              }
              if(index>0 && this.sellDetailsList.length>1)
              {
                  this.sellDetailsList.splice(index,1);
                  this.sellDetailPricesTotal-=priceTemp;

                  // Actualiza el valor total de la factura
                  // this.currentSell.total-=priceTemp;
                  // this.sellForm.patchValue({
                  //   total:this.currentSell.total});

                  this.resultRemoveSellDetail=true;
                  this.currentSellDetail= this.sellDetailsList[index-1];
                  this.positionCurrentSellDetail=index-1;

                  this.sellDetailsForm.patchValue({
                  profesionalId:this.currentSellDetail.profesionalId,
                  serviceTypeId: this.currentSellDetail.serviceTypeId,
                  price:this.currentSellDetail.price,
                  counterSellDetail:this.positionCurrentSellDetail+1,
                  totalSellDetailList:this.sellDetailsList.length
                  })

              }
          this.sellDetailTable.renderRows();
          this.toastr.success('Éxito', 'Se removió el servicio');
            return this.resultRemoveSellDetail;
          }
          else
          {
            this.resultRemoveSellDetail=false;
            this.toastr.error('Fallo', 'No se removió  el servicio');

            return this.resultRemoveSellDetail;
          }
      });

    }

    sellDetailEdit():void
    {
       console.log('entra a sellDetailEdit');
      let currentSellDetailTemp=this.sellDetailsList[this.positionCurrentSellDetail];
      let idTemp=currentSellDetailTemp.sellDetailIdTemp;
      let sellDetailSubServicesTemp=currentSellDetailTemp.subServicesDetails;
      //let priceTemp=currentSellDetailTemp.price;
      let areaIdTemp=currentSellDetailTemp.areaId;

      let bosd: BOSellDetail= new BOSellDetail();
      bosd.profesionalId=this.sellDetailsForm.get('profesionalId').value;
      bosd.serviceTypeId=this.sellDetailsForm.get('serviceTypeId').value;
      bosd.serviceGroupId=this.sellDetailsForm.get('serviceGroupId').value;
      bosd.areaId=parseInt(this.sellDetailsForm.get('areaId').value);


      //bosd.price=parseFloat(this.sellDetailsForm.get('price').value);
      bosd.price=this.sellb.total;
      bosd.sellDetailIdTemp=idTemp;
      bosd.subServicesDetails=sellDetailSubServicesTemp;
      this.sellDetailsList.splice(this.positionCurrentSellDetail,1,bosd);
      // this.sellDetailPricesTotal-=priceTemp;
      // this.sellDetailPricesTotal+=bosd.price;
      //bosd.areaId=this.sellDetailsForm.get('areaId').value;

      this.sellb.areaId=parseInt(this.sellDetailsForm.get('areaId').value);

      this.currentSellDetail=this.sellDetailsList[this.positionCurrentSellDetail];
      this.fillSellDetails();
      //this.showSellDetailSaveBtn? this.showSellDetailSaveBtn=false: this.showSellDetailSaveBtn=true;
      this.showSellDetailSaveBtn==true? this.showSellDetailSaveBtn=false: this.showSellDetailSaveBtn=true;

      //this.sellDetailTable.renderRows();

     //TODO llenar sellDetailsIdTemp
      this.showSellDetailNav=true;
      this.showLastSellDetail=false;
      //this.toastr.success('Éxito en guardar','Se ha guardado el servicio en Edit');

    }

    navNextSellDetail():void
    {

      if(this.positionCurrentSellDetail >=0 && this.positionCurrentSellDetail<= this.sellDetailsList.length-2)
      {
          this.currentSellDetail=this.sellDetailsList[this.positionCurrentSellDetail+1];
          this.positionCurrentSellDetail+=1;
          this.fillSellDetails();
      }

      let svcGroupId=this.currentSellDetail.serviceGroupId;
      let svcGroupIdString=this.convertNumberToString(svcGroupId);
      this.serviceTypeListShort=Utilities.getServicesxGroupId(svcGroupIdString, this.serviceTypeList);

    }

    navBackSellDetail():void
    {
      if(this.positionCurrentSellDetail > 0)
      {
          if(this.positionCurrentSellDetail== this.sellDetailsList.length)
          {
              this.positionCurrentSellDetail-=1;
          }
            this.positionCurrentSellDetail-=1;
            this.currentSellDetail=this.sellDetailsList[this.positionCurrentSellDetail];

      }
        this.fillSellDetails();
        let svcGroupId=this.currentSellDetail.serviceGroupId;
        let svcGroupIdString=this.convertNumberToString(svcGroupId);
        this.serviceTypeListShort=Utilities.getServicesxGroupId(svcGroupIdString, this.serviceTypeList);


    }

    navFirstSellDetail():void{
      this.currentSellDetail=this.sellDetailsList[0];
      this.positionCurrentSellDetail=0;
      this.fillSellDetails();


      let svcGroupId=this.currentSellDetail.serviceGroupId;
      let svcGroupIdString=this.convertNumberToString(svcGroupId);
      this.serviceTypeListShort=Utilities.getServicesxGroupId(svcGroupIdString, this.serviceTypeList);

    }

    navLastSellDetail():void{
      this.currentSellDetail=this.sellDetailsList[this.sellDetailsList.length-1];
      this.positionCurrentSellDetail=this.sellDetailsList.length-1;
      this.fillSellDetails();

      let svcGroupId=this.currentSellDetail.serviceGroupId;
      let svcGroupIdString=this.convertNumberToString(svcGroupId);
      this.serviceTypeListShort=Utilities.getServicesxGroupId(svcGroupIdString, this.serviceTypeList);


    }

  //#endregion sellDetail

//#region payTypeSellDetail

    savePayTypeSellDetail():void
    {
      console.log("En savePayTypeSellDetail this.payTypeSellDetailsList es:", this.payTypeSellDetailsList);
      try
      {
          if(this.payTypeSellDetailsList.length>0)
          {
            this.payTypeGreaterThanZero();
          }
          else
          {
            this.payTypeSmallerOrEqualZero();
          }
      }
      catch (error)
      {
        this.toastr.error('Fallo en guardar','No se ha guardado el pago')
      }
    }

    payTypeSmallerOrEqualZero():void
    {
      console.log('Entra a payTypeSmallerOrEqualZero');
      this.payTypeSellDetailsIdTemp=1;
      let bopt: BOPayTypeSellDetail= new BOPayTypeSellDetail();
      bopt.payTypeId=this.payTypeSellDetailForm.get('payTypeId').value;
      bopt.invoiceTypeId=this.payTypeSellDetailForm.get('invoiceTypeId').value;
      bopt.price=parseFloat(this.payTypeSellDetailForm.get('totalPayTypeSellDetail').value);
      bopt.numberPayTypeSellDetail=this.payTypeSellDetailForm.get('numberPayTypeSellDetail').value;
      bopt.datePayTypeSellDetail=new Date(this.payTypeSellDetailForm.get('datePayTypeSellDetail').value);
      //bopt.payTypeSellDetailBank=this.payTypeSellDetailForm.get('payTypeSellDetailBank').value;
      let tempBank=this.payTypeSellDetailForm.get('payTypeSellDetailBank').value;

      console.log('En ptSmallerZero previo tempBank es',tempBank);
      // if(tempBank.length>0) bopt.payTypeSellDetailBank=tempBank.toUpperCase();
      // else bopt.payTypeSellDetailBank=tempBank;
      bopt.payTypeSellDetailBank=this.payTypeSellDetailForm.get('payTypeSellDetailBank').value;
      console.log('En ptSmallerZero post tempBank es',tempBank);

      bopt.payTypeSellDetailObservations=this.payTypeSellDetailForm.get('payTypeSellDetailObservations').value;
      bopt.payTypeIdTemp=this.payTypeSellDetailsIdTemp;

      bopt.areaId=this.sellb.areaId;
      console.log('En payTypeSmallerZero Antes de guardar bopt es:', bopt);

      this.payTypeSellDetailsList.push(bopt);


      this.payTypePricesTotal+=bopt.price;

      let position=this.payTypeSellDetailsList.length-1;
      this.currentPayTypeSellDetail=this.payTypeSellDetailsList[position];
      this.positionCurrentPayTypeSellDetail=position;

      this.fillPayTypeSellDetails();


      this.showPayTypeSellDetailNav=true;
      this.showLastPayTypeSellDetail=false;
      this.payTypeSellDetailsIdTemp+=1;
      this.showSavePtBtn==true?this.showSavePtBtn=false:this.showSavePtBtn=true;


      //this.toastr.success('Éxito', 'Se guardó con éxito el tipo de pago');

    }

    payTypeGreaterThanZero():void
    {
      console.log('Entra a payTypeGreatherZero');

        let pos=this.positionCurrentPayTypeSellDetail;
        let verifyTemp:number=null;

        if(this.payTypeSellDetailsList[pos] !==null &&  this.payTypeSellDetailsList[pos] !== undefined)
        {
          console.log('idTemp tiene un valor, es:', this.payTypeSellDetailsList[pos]);
        }
        else{
          verifyTemp=-1;
        }

        if(verifyTemp==-1) //no tiene elementos
        {
          console.log('Entra a (verifyTemp==-1 No tiene elementos');
          let bopt: BOPayTypeSellDetail= new BOPayTypeSellDetail();
          bopt.payTypeId=this.payTypeSellDetailForm.get('payTypeId').value;
          bopt.invoiceTypeId=this.payTypeSellDetailForm.get('invoiceTypeId').value;
          bopt.price=parseFloat(this.payTypeSellDetailForm.get('totalPayTypeSellDetail').value);
          bopt.numberPayTypeSellDetail=this.payTypeSellDetailForm.get('numberPayTypeSellDetail').value;
          bopt.datePayTypeSellDetail=new Date(this.payTypeSellDetailForm.get('datePayTypeSellDetail').value);

          let tempBank=this.payTypeSellDetailForm.get('payTypeSellDetailBank').value;
          //console.log('En ptGreatherZero previo tempBank es',tempBank);
          bopt.payTypeSellDetailBank=this.payTypeSellDetailForm.get('payTypeSellDetailBank').value;
          //console.log('En ptGreatherZero post tempBank es',tempBank);

          bopt.payTypeSellDetailObservations=this.payTypeSellDetailForm.get('payTypeSellDetailObservations').value;
          bopt.payTypeIdTemp=this.payTypeSellDetailsIdTemp+1;
          bopt.areaId=this.sellb.areaId;

          console.log('En payTypeGreatherZero Antes de guardar bopt es:', bopt);
          this.payTypeSellDetailsList.push(bopt);

          this.payTypePricesTotal+=bopt.price;
          let position=this.payTypeSellDetailsList.length-1;
          this.currentPayTypeSellDetail=this.payTypeSellDetailsList[position];
          this.positionCurrentPayTypeSellDetail=position;
          this.fillPayTypeSellDetails();
           this.payTypeSellDetailTable.renderRows();

          this.showPayTypeSellDetailNav=true;
          this.showLastPayTypeSellDetail=false;

          this.payTypeSellDetailsIdTemp+=1;
          this.showSavePtBtn==true?this.showSavePtBtn=false:this.showSavePtBtn=true;
          //this.toastr.success('Éxito', 'Se guardó con éxito el tipo de pago');

        }
        else
        {
          this.payTypeEdit();
        }
    }

    payTypeEdit():void
    {
      console.log('Entra a payTypeEdit');

      let idTemp= this.payTypeSellDetailsList[this.positionCurrentPayTypeSellDetail].payTypeIdTemp;
      let priceTemp= this.payTypeSellDetailsList[this.positionCurrentPayTypeSellDetail].price;
      let areaIdTemp= this.payTypeSellDetailsList[this.positionCurrentPayTypeSellDetail].areaId;

      let bopt: BOPayTypeSellDetail= new BOPayTypeSellDetail();

      bopt.payTypeId=this.payTypeSellDetailForm.get('payTypeId').value;
      bopt.invoiceTypeId=this.payTypeSellDetailForm.get('invoiceTypeId').value;
      bopt.price=parseFloat(this.payTypeSellDetailForm.get('totalPayTypeSellDetail').value);
      bopt.numberPayTypeSellDetail=this.payTypeSellDetailForm.get('numberPayTypeSellDetail').value;
      bopt.datePayTypeSellDetail=new Date(this.payTypeSellDetailForm.get('datePayTypeSellDetail').value);
      bopt.payTypeIdTemp=idTemp;

      //bopt.payTypeSellDetailBank=this.payTypeSellDetailForm.get('payTypeSellDetailBank').value;
      let tempBank=this.payTypeSellDetailForm.get('payTypeSellDetailBank').value;
      console.log('En ptEdit previo tempBank es',tempBank);

      // if(tempBank.length>0) bopt.payTypeSellDetailBank=tempBank.toUpperCase();
      // else bopt.payTypeSellDetailBank=tempBank;
      bopt.payTypeSellDetailBank=this.payTypeSellDetailForm.get('payTypeSellDetailBank').value;
      console.log('En ptEdit post tempBank es',tempBank);

      bopt.payTypeSellDetailObservations=this.payTypeSellDetailForm.get('payTypeSellDetailObservations').value;
      bopt.areaId=areaIdTemp;
      console.log('En payTypeEdit Antes de guardar bopt es:', bopt);

      this.payTypeSellDetailsList.splice(this.positionCurrentPayTypeSellDetail,1,bopt);
      //Elimina el valor del payTypeDetail del total
      this.payTypePricesTotal-=priceTemp;
      this.payTypePricesTotal+=bopt.price;

      //
      this.payTypeSellDetailForm.patchValue({
        payTypeId:  bopt.payTypeId,
        invoiceTypeId:bopt.invoiceTypeId,
        numberPayTypeSellDetail: bopt.numberPayTypeSellDetail,
        datePayTypeSellDetail:bopt.datePayTypeSellDetail,
        totalPayTypeSellDetail:bopt.price,
        counterPayTypeSellDetail:this.positionCurrentPayTypeSellDetail+1,
        totalPayTypeSellDetailList:this.payTypeSellDetailsList.length,
        payTypeSellDetailBank:bopt.payTypeSellDetailBank,
        payTypeSellDetailObservations:bopt.payTypeSellDetailObservations,
      })

     // this.fillPayTypeSellDetails();
      this.payTypeSellDetailTable.renderRows();

      this.payTypeSellDetailsIdTemp+=1;
      this.showPayTypeSellDetailNav=true;
      this.showLastPayTypeSellDetail=false;
      this.showSavePtBtn==true?this.showSavePtBtn=false:this.showSavePtBtn=true;
      //this.toastr.success('Éxito', 'Se guardó con éxito el tipo de pago');


    }

    removePayTypeSellDetailById(id:number):void
    {
      //this.resultRemoveSellDetail=false;
      this.resultRemovePayTypeSellDetail=false;
      let confirm:boolean=false;

      this._dialogConfirm.openConfirmDialog('¿Está seguro que quiere borrar este elemento?')
      .afterClosed().subscribe(res=>{
        confirm=res;

        if(confirm)
        {
            const index=this.payTypeSellDetailsList.findIndex(item=>item.payTypeIdTemp==id);
            let priceTemp:number=this.payTypeSellDetailsList[index].price;


            if(index==0 && this.payTypeSellDetailsList.length==1)
            {
                  this.payTypeSellDetailsList.splice(index,1);
                  this.resultRemovePayTypeSellDetail=true;
                  this.currentPayTypeSellDetail=null;

                  this.payTypePricesTotal-=priceTemp;

                //  this.payTypeSellDetailForm.reset();
                  this.fillPayTypeSellDetails();
                  this.positionCurrentPayTypeSellDetail=null;
            }

            if(index==0 && this.payTypeSellDetailsList.length>1)
            {
                    this.payTypeSellDetailsList.splice(index,1);
                    this.payTypePricesTotal-=priceTemp;
                    this.resultRemovePayTypeSellDetail=true;
                    this.currentPayTypeSellDetail= this.payTypeSellDetailsList[0];

                    this.positionCurrentPayTypeSellDetail=0;

                    this.payTypeSellDetailForm.patchValue({
                      payTypeId:this.currentPayTypeSellDetail.payTypeId,
                      numberPayTypeSellDetail: this.currentPayTypeSellDetail.numberPayTypeSellDetail,
                      datePayTypeSellDetail:this.currentPayTypeSellDetail.datePayTypeSellDetail,
                      totalPayTypeSellDetail:this.currentPayTypeSellDetail.price,
                      counterPayTypeSellDetail:this.positionCurrentPayTypeSellDetail+1,
                      totalPayTypeSellDetailList:this.payTypeSellDetailsList.length,

                      payTypeSellDetailBank:this.currentPayTypeSellDetail.payTypeSellDetailBank,
                      payTypeSellDetailObservations:this.currentPayTypeSellDetail.payTypeSellDetailObservations,
                    })

            }

            if(index>0 && this.payTypeSellDetailsList.length>1)
            {
                this.payTypeSellDetailsList.splice(index,1);
                this.payTypePricesTotal-=priceTemp;

                  this.resultRemovePayTypeSellDetail=true;
                  this.currentPayTypeSellDetail= this.payTypeSellDetailsList[index-1];
                  this.positionCurrentPayTypeSellDetail=index-1;

                  this.payTypeSellDetailForm.patchValue({
                    payTypeId:this.currentPayTypeSellDetail.payTypeId,
                    numberPayTypeSellDetail: this.currentPayTypeSellDetail.numberPayTypeSellDetail,
                    datePayTypeSellDetail:this.currentPayTypeSellDetail.datePayTypeSellDetail,
                    totalPayTypeSellDetail:this.currentPayTypeSellDetail.price,
                    counterPayTypeSellDetail:this.positionCurrentPayTypeSellDetail+1,
                    totalPayTypeSellDetailList:this.payTypeSellDetailsList.length,

                    payTypeSellDetailBank:this.currentPayTypeSellDetail.payTypeSellDetailBank,
                    payTypeSellDetailObservations:this.currentPayTypeSellDetail.payTypeSellDetailObservations,

                  })

            }

           this.payTypeSellDetailTable.renderRows();
           this.toastr.success('Éxito', 'Se removió el tipo de pago');


            return this.resultRemovePayTypeSellDetail;
          }
          else
          {
            this.resultRemovePayTypeSellDetail=false;
            this.toastr.error('Fallo', 'No se removió el tipo de pago');

            return this.resultRemovePayTypeSellDetail;
          }
      });

    }
//#endregion PayTypeSellDetail

//#region SubServiceDetail

openSubServiceModal(sellDetailIdX: number, origen: number):void
{
  console.log("Entra a openSubServiceModal");
  let sdetails= this.sellb.sellDetails;
  let sdChoosed=sdetails.find(x=>x.sellDetailIdTemp==sellDetailIdX);
  this.currentSellDetail=sdChoosed;

  this.serviceTypeListShort=[];
  this.subServiceTypeListShort=[];
  this.subServicesByCurrentSdList=[];

    this.subServicesPricesTotal =0;
    this.subServicesPricesBySellDetail =0;
    this.positionCurrentSubServiceDetail=-10;
    this.currentSubServiceDetail= new BOSubServiceDetail();
    this.currentSubServiceDetail.subServiceDetailIdTemp=0;
    this.currentSubServiceDetail.sellDetailIdTemp=10000;
    this.currentSubServiceDetail.itemSaved=false;
    this.subServiceDetailIdTemp=0;

    this.currentSubServiceDetail.subServiceGroupId=this.currentSellDetail.serviceGroupId;
    this.currentSubServiceDetail.serviceTypeId=this.currentSellDetail.serviceTypeId;
    this.currentSubServiceDetail.profesionalId=this.currentSellDetail.profesionalId;
    this.currentSubServiceDetail.price=this.currentSellDetail.price;
    this.currentSubServiceDetail.date=this.sellb.dateSell;


  let sbSvcGroupId=sdChoosed.serviceGroupId;

  let sbSvcGroupIdString=this.convertNumberToString(sbSvcGroupId);
  this.serviceTypeListShort=Utilities.getServicesxGroupId(sbSvcGroupIdString, this.serviceTypeList);

  let svcId=sdChoosed.serviceTypeId;
  // this.subServiceTypeListShort=Utilities.getSubServicesxServiceId(svcId, this.subServiceTypeList);
  // this.filteredSubServicesShort.next(this.subServiceTypeListShort.slice());

  this.fillSubServiceDetails();

  this.subServiceDetailIdTemp+=1;

  this.showSubServiceDetailNav=false;

  this.createSubServiceModal.config = { backdrop: "static", keyboard: false };
  this.createSubServiceModal.show();

}

// protected filterSubServiceShort() {
//     if (!this.subServiceTypeListShort) {
//         return;
//     }
//     // get the search keyword
//     const search = this.subServiceFilterCtrl.value;
//     // let search = "";

//     if (!search) {
//         this.filteredSubServicesShort.next(this.subServiceTypeListShort.slice());
//         return;
//     }
//     else
//     {
//         this.searchingSubService = true;
//         this._subServiceType.getSubServicesByService(search).subscribe(data => {
//             this.subServiceTypeListShort = data;
//             this.filteredSubServicesShort.next(data);
//             this.searchingSubService = false;
//         }, error => {
//             this.filteredSubServicesShort.next(this.subServiceTypeListShort.slice());
//             this.searchingSubService = false;
//         });
//     }
//   this.searchingSubService = true;

//   const searchLower = search.toLowerCase().trim();

//   const filtered = this.subServiceTypeListShort.filter(item =>
//     item.name.toLowerCase().includes(searchLower)
//   );

//   this.subServiceTypeListShort = filtered;
//   this.filteredSubServicesShort.next(filtered);
//   this.searchingSubService = false;

// }
// protected filterSubServiceShort() {
//     if (!this.subServiceTypeListShort) {
//         return;
//     }

//     const search = this.subServiceFilterCtrl.value;

//     if (!search) {
//         this.filteredSubServicesShort.next(this.subServiceTypeListShort.slice());
//         return;
//     }

//     const searchLower = search.toLowerCase().trim();

//     // Filtra sobre la lista original SIN mutarla
//     const filtered = this.subServiceTypeListShort.filter(item =>
//         item.name.toLowerCase().includes(searchLower)
//     );

//     this.filteredSubServicesShort.next(filtered);
// }
protected filterSubServiceShort() {
    console.log('🔍 [filterSubServiceShort] Método invocado');
    console.log('🔍 [filterSubServiceShort] subServiceTypeListShort actual:', this.subServiceTypeListShort);
    console.log('🔍 [filterSubServiceShort] Cantidad items en lista:', this.subServiceTypeListShort?.length);

    if (!this.subServiceTypeListShort) {
        console.warn('⚠️ [filterSubServiceShort] subServiceTypeListShort es null/undefined. Saliendo.');
        return;
    }

    const search = this.subServiceFilterCtrl.value;
    console.log('🔍 [filterSubServiceShort] Valor del control de búsqueda:', search);

    if (!search) {
        console.log('🔍 [filterSubServiceShort] Búsqueda vacía, emitiendo lista completa');
        this.filteredSubServicesShort.next(this.subServiceTypeListShort.slice());
        return;
    }

    const searchLower = search.toLowerCase().trim();
    console.log('🔍 [filterSubServiceShort] Término de búsqueda normalizado:', searchLower);

    const filtered = this.subServiceTypeListShort.filter(item => {
        const match = item.name.toLowerCase().includes(searchLower);
        console.log(`🔍 [filterSubServiceShort] Item: "${item.name}" → match: ${match}`);
        return match;
    });

    console.log('🔍 [filterSubServiceShort] Resultados filtrados:', filtered);
    console.log('🔍 [filterSubServiceShort] Cantidad resultados:', filtered.length);

    this.filteredSubServicesShort.next(filtered);
}

openSubServiceModalEdit(sellDetailIdX: number, origen?: number):void
{

  this.subServiceDetailIdTemp    =900;

  this.serviceTypeListShort=[];
  this.subServiceTypeListShort=[];
  this.subServicesPricesTotal =0;
  this.subServicesPricesBySellDetail =0;


  this.subServicesByCurrentSdList=[];

  let sdetails= this.sellb.sellDetails;
  let sdChoosed=sdetails.find(x=>x.sellDetailIdTemp==sellDetailIdX);

  if(sdChoosed.subServicesDetails.length>0)
  {


    let sbSvces=sdChoosed.subServicesDetails;

    for(let i=0;i> sbSvces.length; i++)
    {
      sbSvces[i].subServiceDetailIdTemp=this.subServiceDetailIdTemp;
      sbSvces[i].itemSaved=true;
      this.subServicesPricesBySellDetail+=sbSvces[i].price;
      this.subServiceDetailIdTemp+=1;

    }

    this.currentSellDetail=sdChoosed;
    this.subServicesByCurrentSdList=sdChoosed.subServicesDetails;
    this.currentSubServiceDetail=this.subServicesByCurrentSdList[0];
    this.positionCurrentSubServiceDetail=0;


  }

  if(this.currentSellDetail.subServicesDetails.length>0)
  {
    this.subServicesByCurrentSdList=sdChoosed.subServicesDetails;

    this.subServicesByCurrentSdList.forEach(sub=>{
     //sub.sellDetailIdTemp=this.subServiceDetailIdTemp;
      sub.subServiceDetailIdTemp=this.subServiceDetailIdTemp;

      sub.itemSaved=true;
      this.subServicesPricesBySellDetail+=sub.price;
      this.subServiceDetailIdTemp+=1;
    })

    this.currentSubServiceDetail=this.subServicesByCurrentSdList[0];
    this.positionCurrentSubServiceDetail=0;

    let sbSvcGroupId=this.currentSubServiceDetail.subServiceGroupId;
    let sbSvcGroupIdString=this.convertNumberToString(sbSvcGroupId);
    this.serviceTypeListShort=Utilities.getServicesxGroupId(sbSvcGroupIdString, this.serviceTypeList);

    let svcId=this.currentSubServiceDetail.serviceTypeId;
    this.subServiceTypeListShort=Utilities.getSubServicesxServiceId(svcId, this.subServiceTypeList);

      this.subServiceDetailForm.patchValue({
      subServiceGroupId:        this.currentSubServiceDetail.subServiceGroupId,
      subServiceTypeId:         this.currentSubServiceDetail.subServiceTypeId,
      serviceTypeId:            this.currentSubServiceDetail.serviceTypeId,
      profesionalId:            this.currentSubServiceDetail.profesionalId,
      dateSubService:           this.currentSubServiceDetail.date,
     // price:                    this.currentSubServiceDetail.price,
      //TODO
      counterSubServiceDetail:  this.subServicesByCurrentSdList.length> 0? 1: this.positionCurrentSubServiceDetail,
      totalSubServiceDetailList:this.subServicesByCurrentSdList.length,

      observations:             this.currentSubServiceDetail.observations,
    })

    this.showSubServiceDetailNav=true;
    this.createSubServiceModal.config = { backdrop: "static", keyboard: false };
    this.createSubServiceModal.show();

  }

  else
  {
    this.toastr.error('No registros', 'El servicio no tiene subservicios')
  }
}

closeSubServiceModal():void
{
      this.showLastSubServiceDetail=false;
      this.clearSubServiceDetail();

    this.createSubServiceModal.hide();
}

saveSubServiceDetail():void
    {
      try
      {
          if(this.subServicesByCurrentSdList.length>0)

          {
            this.subServiceDetailGreaterThanZero();
          }
          else
          {
            this.subServiceDetailSmallerOrEqualZero()
          }

         // this.showSaveSbvcBtn=true?this.showSaveSbvcBtn=false:this.showSaveSbvcBtn=true;

      }
      catch (error)
      {
        this.toastr.error('Fallo en guardar','No se ha guardado el subService')
      }
}

subServiceDetailGreaterThanZero():void
    {
        console.log('Entra a subServiceDDetailGreather');
        let pos=this.positionCurrentSubServiceDetail;
        let verifyTemp:number=null;

        if(this.subServicesByCurrentSdList[pos] !==null &&  this.subServicesByCurrentSdList[pos] !== undefined)
        {
          console.log('(this.subServicesByCurrentSdList[pos] tiene un valor, es:', this.subServicesByCurrentSdList[pos]);
        }
        else{
          verifyTemp=-1;
        }

        if(verifyTemp==-1) //pos no tiene elementos
        {
          console.log('En subServiceDDetailGreather entra a verifyTemp==-1');

          let bopt: BOSubServiceDetail= new BOSubServiceDetail();
          bopt.subServiceTypeId=parseInt(this.subServiceDetailForm.get('subServiceTypeId').value);
          bopt.subServiceName=this.subServiceTypeList.find(x=>x.id==bopt.subServiceTypeId)?.name;

          bopt.subServiceGroupId=parseInt(this.subServiceDetailForm.get('subServiceGroupId').value);
          bopt.subServiceGroupId=parseInt(this.subServiceDetailForm.get('subServiceGroupId').value);
          bopt.subServiceGroupName=this.serviceGroupList.find(x=>x.id== bopt.subServiceGroupId)?.name;

          bopt.sellDetailId=this.sellDetailId;
          bopt.serviceTypeId=this.subServiceDetailForm.get('serviceTypeId').value;
          bopt.serviceName=this.serviceTypeList.find(x=>x.id==bopt.serviceTypeId)?.name;
          bopt.profesionalId=parseInt(this.subServiceDetailForm.get('profesionalId').value);
          bopt.profesionalName=this.getProfesionalName(bopt.profesionalId);
          bopt.date=new Date(this.subServiceDetailForm.get('dateSubService').value);
          bopt.observations=this.subServiceDetailForm.get('observations').value;
         // bopt.price=parseFloat(this.subServiceDetailForm.get('price').value);
          bopt.price=this.sellb.total
          bopt.subServiceTypeIdTemp=this.subServiceTypeIdTemp;
          bopt.sellDetailIdTemp=this.currentSellDetail.sellDetailIdTemp;
          bopt.sellDetailId=this.currentSellDetail.id;
          bopt.subServiceDetailIdTemp=this.subServiceDetailIdTemp;

          bopt.areaId=parseInt(this.sellDetailsForm.get('areaId').value);

         // bopt.areaId=this.sellb.areaId;
          bopt.itemSaved=true;

         let counterSb=0;

         this.subServiceDetailList.push(bopt);
         this.subServicesByCurrentSdList=this.addDataToArray(bopt, this.subServicesByCurrentSdList);
         this.currentSellDetail.subServicesDetails.push(bopt);

        //  this.subServicesPricesTotal+=bopt.price;
        //  this.subServicesPricesBySellDetail+=bopt.price;

          let position=this.subServicesByCurrentSdList.length-1;

          this.currentSubServiceDetail=this.subServicesByCurrentSdList[position];

          this.positionCurrentSubServiceDetail=position;
          this.subServiceTypeIdTemp +=1;
          this.subServiceDetailIdTemp+=1;

          this.fillSubServiceDetails();
         // this.subServiceDetailTable.renderRows();

          this.showSubServiceDetailNav=true;
          this.showLastSubServiceDetail=false;
          this.showSaveSbvcBtn==true?this.showSaveSbvcBtn=false:this.showSaveSbvcBtn=true;
          //this.toastr.success('Éxito', 'Se guardó con éxito el procedimiento');


        }
        else
        {
          this.subServiceEdit();
        }
}

subServiceDetailSmallerOrEqualZero():void
{
  console.log('Entra a subServiceDDetailSmaller');

      let bopt: BOSubServiceDetail= new BOSubServiceDetail();
      bopt.subServiceTypeId=parseInt(this.subServiceDetailForm.get('subServiceTypeId').value);
      bopt.subServiceName=this.subServiceTypeList.find(x=>x.id==bopt.subServiceTypeId)?.name;
      bopt.subServiceGroupId=parseInt(this.sellDetailsForm.get('serviceGroupId').value);
      bopt.subServiceGroupName=this.serviceGroupList.find(x=>x.id== bopt.subServiceGroupId)?.name;
      bopt.sellDetailId=this.sellDetailId;
      bopt.serviceTypeId=parseInt(this.sellDetailsForm.get('serviceTypeId').value);
      bopt.serviceName=this.serviceTypeList.find(x=>x.id==bopt.serviceTypeId)?.name;
     // bopt.profesionalId=parseInt(this.sellDetailsForm.get('profesionalId').value);
      bopt.profesionalId=parseInt(this.subServiceDetailForm.get('profesionalId').value);
      bopt.profesionalName=this.getProfesionalName(bopt.profesionalId);
      bopt.date=this.sellb.dateSell;
      bopt.observations=this.subServiceDetailForm.get('observations').value;
      bopt.sellDetailIdTemp=this.currentSellDetail.sellDetailIdTemp;
      bopt.subServiceTypeIdTemp=this.subServiceTypeIdTemp;
      bopt.subServiceDetailIdTemp=this.subServiceDetailIdTemp;
      bopt.itemSaved=true;
     // bopt.areaId=this.sellb.areaId;
     bopt.price=this.sellb.total;
     bopt.areaId=parseInt(this.sellDetailsForm.get('areaId').value);

      this.subServiceDetailList.push(bopt);
     this.subServicesByCurrentSdList=this.addDataToArray(bopt, this.subServicesByCurrentSdList);

     this.currentSellDetail.subServicesDetails.push(bopt);

      let position=this.subServicesByCurrentSdList.length-1;

      this.currentSubServiceDetail=this.subServicesByCurrentSdList[position];

      this.positionCurrentSubServiceDetail=position;

      this.fillSubServiceDetails();

      this.showSubServiceDetailNav=true;
      this.showLastSubServiceDetail=false;

      this.subServiceTypeIdTemp +=1;
      this.subServiceDetailIdTemp+=1;
      this.showSaveSbvcBtn==true?this.showSaveSbvcBtn=false:this.showSaveSbvcBtn=true;

}

subServiceEdit():void
{
      console.log('Entra a subServiceEdit');


     // let idTempSellDetail= this.subServicesByCurrentSdList[this.positionCurrentSubServiceDetail].sellDetailIdTemp;
     let idTempSellDetail= this.currentSellDetail.sellDetailIdTemp;

      let idTempSubService=this.subServicesByCurrentSdList[this.positionCurrentSubServiceDetail].subServiceDetailIdTemp;
      //let priceTemp=this.subServicesByCurrentSdList[this.positionCurrentSubServiceDetail].price;
      let areaTemp= this.subServicesByCurrentSdList[this.positionCurrentSubServiceDetail].areaId;
      //this.currentSellDetail=this.sellb.sellDetails[0];
      let sbsvc=this.subServicesByCurrentSdList[0];

      //this.showSellDetailSaveBtn=false;

      let bopt: BOSubServiceDetail= new BOSubServiceDetail();

      bopt.subServiceTypeId=this.subServiceDetailForm.get('subServiceTypeId').value;
      bopt.subServiceName=this.subServiceTypeList.find(x=>x.id==bopt.subServiceTypeId)?.name;

      //bopt.subServiceGroupId=this.currentSellDetail.serviceGroupId;
      bopt.subServiceGroupId=parseInt(this.sellDetailsForm.get('serviceGroupId').value);
      bopt.subServiceGroupName=this.serviceGroupList.find(x=>x.id== bopt.subServiceGroupId)?.name;

      bopt.sellDetailId=this.sellDetailId;
    // bopt.serviceTypeId=this.currentSellDetail.serviceTypeId;
      bopt.serviceTypeId=parseInt(this.sellDetailsForm.get('serviceTypeId').value);
      bopt.serviceName=this.serviceTypeList.find(x=>x.id==bopt.serviceTypeId)?.name;

     // bopt.profesionalId=sbsvc.profesionalId;
      //bopt.profesionalId=parseInt(this.sellDetailsForm.get('profesionalId').value);
      bopt.profesionalId=parseInt(this.subServiceDetailForm.get('profesionalId').value);
      bopt.profesionalName=this.getProfesionalName(bopt.profesionalId);

      bopt.date=this.sellb.dateSell;

      bopt.observations=this.subServiceDetailForm.get('observations').value;
      bopt.price=this.sellb.total;
      bopt.sellDetailIdTemp=idTempSellDetail;
      bopt.subServiceDetailIdTemp=idTempSubService;
      bopt.itemSaved=true;
      //bopt.areaId=areaTemp;
      bopt.price=this.sellb.total;
      bopt.areaId=parseInt(this.sellDetailsForm.get('areaId').value);

     this.subServicesByCurrentSdList.splice(this.positionCurrentSubServiceDetail,1,bopt);
     this.currentSubServiceDetail= this.subServicesByCurrentSdList[this.positionCurrentSubServiceDetail];


      //1. Elimina el valor del sellCurrent.total
      // this.subServicesPricesTotal-=priceTemp;
      // this.subServicesPricesBySellDetail-=priceTemp;


      //2.Adiciona el valor de price
      this.subServicesPricesTotal+=bopt.price;
      this.subServicesPricesBySellDetail+=bopt.price;


      this.fillSubServiceDetails();
     // this.subServiceDetailTable.renderRows();

      this.showSubServiceDetailNav=true;
      this.showLastSubServiceDetail=false;

      this.showSaveSbvcBtn==true?this.showSaveSbvcBtn=false:this.showSaveSbvcBtn=true;

      //this.toastr.success('Éxito', 'Se guardó con éxito el procedimiento');

}

removeFromSbsvcsByCurrentSdListById(subServiceDetailIdTemp:number):void
    {
      this.resultRemoveSubServiceDetail=false;
      let confirm:boolean=false;

      this._dialogConfirm.openConfirmDialog('¿Está seguro que quiere borrar este elemento?')
      .afterClosed().subscribe(res=>{
        confirm=res;

        if(confirm)
        {
          //edita el elemento de la lista general
          const indexForList=this.subServiceDetailList.findIndex(item=>item.subServiceDetailIdTemp==subServiceDetailIdTemp);
          this.subServiceDetailList.splice(indexForList,1);

          //edita el elemento de la lista particular

            const index=this.subServicesByCurrentSdList.findIndex(item=>item.subServiceDetailIdTemp==subServiceDetailIdTemp);
            const subServiceChoosed=this.subServicesByCurrentSdList[index];
            const currentSellDetailIdTemp=subServiceChoosed.sellDetailIdTemp;
            let priceTemp:number=this.subServicesByCurrentSdList[index].price;

            if(index==0 && this.subServicesByCurrentSdList.length==1)
            {
              this.subServicesByCurrentSdList.splice(index,1);
              this.subServicesPricesTotal-=priceTemp;
              this.subServicesPricesBySellDetail-=priceTemp;

              this.resultRemoveSubServiceDetail=true;
              this.currentSubServiceDetail=null;
              this.currentSubServiceDetail= new BOSubServiceDetail();
              this.currentSubServiceDetail.sellDetailIdTemp=10000;
              this.currentSubServiceDetail.subServiceDetailIdTemp=0;

              //this.positionCurrentSubServiceDetail=0;
              this.positionCurrentSubServiceDetail=-5;

              //esconde el botón de añadir nuevo
              this.showSubServiceDetailNav=false;
              //
              this.currentSellDetail.subServicesDetails=[];

                this.subServicesByCurrentSdList=[];

                this.subServiceDetailForm.patchValue({
                  subServiceGroupId: null,
                  subServiceTypeId:  null,
                  serviceTypeId:     null,
                  profesionalId:     null,
                  dateSubService:    null,
                  price:             null,
                  counterSubServiceDetail  :0,
                  totalSubServiceDetailList:0,
                  observations:      null,
                });

                  this.subServiceDetailForm.reset();
                  this.positionCurrentSubServiceDetail=null;
            }

            if(index==0 && this.subServicesByCurrentSdList.length>1)
            {
                    this.subServicesByCurrentSdList.splice(index,1);
                    this.subServicesPricesTotal-=priceTemp;
                    this.subServicesPricesBySellDetail-=priceTemp;

                    this.resultRemoveSubServiceDetail=true;
                    this.currentSubServiceDetail= this.subServicesByCurrentSdList[0];
                    let currentSubServiceDetailTest= this.subServicesByCurrentSdList[currentSellDetailIdTemp];

                    this.positionCurrentSubServiceDetail=0;
                  this.subServiceDetailForm.patchValue({
                    subServiceGroupId:this.currentSubServiceDetail.subServiceGroupId,
                    serviceTypeId:this.currentSubServiceDetail.serviceTypeId,
                    subServiceTypeId:this.currentSubServiceDetail.subServiceTypeId,
                    profesionalId:  this.currentSubServiceDetail.profesionalId,
                    dateSubService: this.currentSubServiceDetail.date,
                    price:this.currentSubServiceDetail.price,
                    observations:this.currentSubServiceDetail.observations,
                    counterSubServiceDetail:this.positionCurrentSubServiceDetail+1,
                    totalSubServiceDetailList:this.subServicesByCurrentSdList.length
                  })
            }

            if(index>0 && this.subServicesByCurrentSdList.length>1)
            {
                this.subServicesByCurrentSdList.splice(index,1);

                this.subServicesPricesTotal-=priceTemp;
                this.subServicesPricesBySellDetail-=priceTemp;

                this.resultRemoveSubServiceDetail=true;

                this.currentSubServiceDetail= this.subServicesByCurrentSdList[index-1];
                this.positionCurrentSubServiceDetail=index-1;

                this.subServiceDetailForm.patchValue({
                  subServiceGroupId:this.currentSubServiceDetail.subServiceGroupId,
                  serviceTypeId:this.currentSubServiceDetail.serviceTypeId,
                  subServiceTypeId:this.currentSubServiceDetail.subServiceTypeId,
                  profesionalId:  this.currentSubServiceDetail.profesionalId,
                  dateSubService: this.currentSubServiceDetail.date,
                  price:this.currentSubServiceDetail.price,
                  observations:this.currentSubServiceDetail.observations,
                  counterSubServiceDetail:this.positionCurrentSubServiceDetail+1,
                  totalSubServiceDetailList:this.subServicesByCurrentSdList.length

                })

            }

            if(this.subServicesByCurrentSdList.length>0)
            {
                let sbSvcGroupId=this.currentSubServiceDetail.subServiceGroupId;
                let sbSvcGroupIdString=this.convertNumberToString(sbSvcGroupId);
                this.serviceTypeListShort=Utilities.getServicesxGroupId(sbSvcGroupIdString, this.serviceTypeList);

                let svcId=this.currentSubServiceDetail.serviceTypeId;
                 this.subServiceTypeListShort=Utilities.getSubServicesxServiceId(svcId, this.subServiceTypeList);

            }

            this.subServiceDetailTable.renderRows();
            this.toastr.success('Éxito', 'Se removió el procedimiento');

            return this.resultRemoveSubServiceDetail;
        } //
        else
        {
            this.resultRemoveSubServiceDetail=false;
            this.toastr.success('Fallo', 'No se removió el procedimiento');

            return this.resultRemoveSubServiceDetail;
        }

      });




    }
    //#endregion SubServiceDetail

//#region navigation


    navNextPayTypeSellDetail():void
    {

      if(this.positionCurrentPayTypeSellDetail >=0 && this.positionCurrentPayTypeSellDetail<= this.payTypeSellDetailsList.length-2)
      {
          this.currentPayTypeSellDetail=this.payTypeSellDetailsList[this.positionCurrentPayTypeSellDetail+1];
          this.positionCurrentPayTypeSellDetail+=1;
          this.fillPayTypeSellDetails();
      }

    }

    navBackPayTypeSellDetail():void{
      if(this.positionCurrentPayTypeSellDetail > 0)
        {
          if(this.positionCurrentPayTypeSellDetail== this.payTypeSellDetailsList.length)
          {
              this.positionCurrentPayTypeSellDetail-=1;
          }
          this.positionCurrentPayTypeSellDetail-=1;
          this.currentPayTypeSellDetail=this.payTypeSellDetailsList[this.positionCurrentPayTypeSellDetail];

        }
        this.fillPayTypeSellDetails();
    }

    navFirstPayTypeSellDetail():void{
      this.currentPayTypeSellDetail=this.payTypeSellDetailsList[0];
      this.positionCurrentPayTypeSellDetail=0;
      this.fillPayTypeSellDetails();
    }

    navLastPayTypeSellDetail():void{
      this.currentPayTypeSellDetail=this.payTypeSellDetailsList[this.payTypeSellDetailsList.length-1];
      this.positionCurrentPayTypeSellDetail=this.payTypeSellDetailsList.length-1;
      this.fillPayTypeSellDetails();
    }

    // async navNextSubServiceDetail():Promise<void>
    navNextSubServiceDetail():void
    {

      if(this.positionCurrentSubServiceDetail >=0 && this.positionCurrentSubServiceDetail<= this.subServicesByCurrentSdList.length-2)
      {
          this.currentSubServiceDetail=this.subServicesByCurrentSdList[this.positionCurrentSubServiceDetail+1];
          this.positionCurrentSubServiceDetail+=1;
          this.fillSubServiceDetails();
      }
      let sbSvcGroupId=this.currentSubServiceDetail.subServiceGroupId;
      let sbSvcGroupIdString=this.convertNumberToString(sbSvcGroupId);
      this.serviceTypeListShort=Utilities.getServicesxGroupId(sbSvcGroupIdString, this.serviceTypeList);

      let svcId=this.currentSubServiceDetail.serviceTypeId;
       this.subServiceTypeListShort=Utilities.getSubServicesxServiceId(svcId, this.subServiceTypeList);

    }

    navBackSubServiceDetail():void{

      if(this.positionCurrentSubServiceDetail > 0)
        {
          if(this.positionCurrentSubServiceDetail== this.subServicesByCurrentSdList.length)
          {
              this.positionCurrentSubServiceDetail-=1;
          }
          this.positionCurrentSubServiceDetail-=1;

          this.currentSubServiceDetail=this.subServicesByCurrentSdList[this.positionCurrentSubServiceDetail];

         let sbSvcGroupId=this.currentSubServiceDetail.subServiceGroupId;
         let sbSvcGroupIdString=this.convertNumberToString(sbSvcGroupId);
         this.serviceTypeListShort=Utilities.getServicesxGroupId(sbSvcGroupIdString, this.serviceTypeList);

         let svcId=this.currentSubServiceDetail.serviceTypeId;
          this.subServiceTypeListShort=Utilities.getSubServicesxServiceId(svcId, this.subServiceTypeList);

          this.subServiceDetailForm.patchValue({
            subServiceGroupId:this.currentSubServiceDetail.subServiceGroupId,
            serviceTypeId:this.currentSubServiceDetail.serviceTypeId,
            subServiceTypeId:this.currentSubServiceDetail.subServiceTypeId,
            profesionalId: this.currentSubServiceDetail.profesionalId,
            price:this.currentSubServiceDetail.price,
            counterSubServiceDetail:this.positionCurrentSubServiceDetail+1

          })

        }


    }

    navFirstSubServicesDetail():void{
      this.currentSubServiceDetail=this.subServicesByCurrentSdList[0];

      this.positionCurrentSubServiceDetail=0;

      let sbSvcGroupId=this.currentSubServiceDetail.subServiceGroupId;
      let sbSvcGroupIdString=this.convertNumberToString(sbSvcGroupId);
      this.serviceTypeListShort=Utilities.getServicesxGroupId(sbSvcGroupIdString, this.serviceTypeList);

      let svcId=this.currentSubServiceDetail.serviceTypeId;
       this.subServiceTypeListShort=Utilities.getSubServicesxServiceId(svcId, this.subServiceTypeList);


      this.fillSubServiceDetails();
    }

    navLastSubServicesDetail():void{
      this.currentSubServiceDetail=this.subServicesByCurrentSdList[0];

      this.currentSubServiceDetail=this.subServicesByCurrentSdList[this.subServicesByCurrentSdList.length-1];
      this.positionCurrentSubServiceDetail=this.subServicesByCurrentSdList.length-1;

      let sbSvcGroupId=this.currentSubServiceDetail.subServiceGroupId;
      let sbSvcGroupIdString=this.convertNumberToString(sbSvcGroupId);
      this.serviceTypeListShort=Utilities.getServicesxGroupId(sbSvcGroupIdString, this.serviceTypeList);

      let svcId=this.currentSubServiceDetail.serviceTypeId;
      this.subServiceTypeListShort=Utilities.getSubServicesxServiceId(svcId, this.subServiceTypeList);
      this.fillSubServiceDetails();
    }

    //#endregion navigation


//#region fill & addNew
// fillSell():void{
//       this.sellForm.patchValue({
//         observations:this.currentSell.observations,
//       })
// }

fillSell():void{

  this.sellForm.patchValue({
    idTypeIdentification:this.currentSell.idTypeIdentification,
    documentNumber:this.currentSell.documentNumber,
    invoiceTypeId:this.currentSell.invoiceTypeId,
    total:this.currentSell.total,
    dateSell:this.currentSell.dateSell,

   //serId:this.currentSell.userId,
    userId:this.currentSell.userIdString,

    userName:this.currentSell.userName,
    userEmail:this.currentSell.userEmail,
    observations:this.currentSell.observations,
  })

}


fillSellDetails():void
    {
      //console.log('Entra a fillSellDetails');

      if(!this.currentSellDetail)
      {
        this.sellDetailsForm.patchValue({
          profesionalId:null,
          serviceTypeId: null,
          serviceGroupId:null,
          areaId:null,
          //price:null,
          //counterSellDetail:null,
          //totalSellDetailList:0


        });
      }
      else{

        this.sellDetailsForm.patchValue({
          profesionalId:this.currentSellDetail.profesionalId,
          serviceTypeId:this.currentSellDetail.serviceTypeId,
          serviceGroupId: this.currentSellDetail.serviceGroupId,
          areaId:this.currentSellDetail.areaId
          //price: this.currentSellDetail.price,
        });

      }

}

fillSubServiceDetails():void
    {

      if(!this.currentSubServiceDetail
        || this.currentSubServiceDetail===null
        || this.positionCurrentSubServiceDetail==-5)
      {
        this.subServiceDetailForm.patchValue({
          subServiceTypeId:  null,
          profesionalId:null,
          observations:      null,
        });


      }
      else
      {
        let convertedGroupIdToString= this.convertNumberToString(this.currentSubServiceDetail.subServiceGroupId);

        if(this.currentSubServiceDetail.subServiceTypeId >0){
          let convertedServiceTypeId=this.convertNumberToString(this.currentSubServiceDetail.serviceTypeId);
        }

        this.subServiceDetailForm.patchValue({
          subServiceTypeId:         this.currentSubServiceDetail.subServiceTypeId,
          profesionalId:             this.currentSubServiceDetail.profesionalId,
          observations:             this.currentSubServiceDetail.observations,
        });
      }

}

fillPayTypeSellDetails():void
{
      if(!this.currentPayTypeSellDetail || this.currentPayTypeSellDetail==null)
      {
        this.payTypeSellDetailForm.patchValue({
          payTypeId:1,
          invoiceTypeId:2,
          numberPayTypeSellDetail: null,
          datePayTypeSellDetail: this.sellb.dateSell,

          totalPayTypeSellDetail: this.sellb.total,
          counterPayTypeSellDetail:null,
          totalPayTypeSellDetailList:null,
          payTypeSellDetailBank:null,
          payTypeSellDetailObservations:null
        })

      }
      else
      {
        this.payTypeSellDetailForm.patchValue({
          payTypeId:this.currentPayTypeSellDetail.payTypeId,
          invoiceTypeId:this.currentPayTypeSellDetail.invoiceTypeId,
          numberPayTypeSellDetail: this.currentPayTypeSellDetail.numberPayTypeSellDetail,
          datePayTypeSellDetail:this.currentPayTypeSellDetail.datePayTypeSellDetail,
          totalPayTypeSellDetail:this.currentPayTypeSellDetail.price,
          counterPayTypeSellDetail:this.positionCurrentPayTypeSellDetail+1,
          totalPayTypeSellDetailList:this.payTypeSellDetailsList.length,

          payTypeSellDetailBank:this.currentPayTypeSellDetail.payTypeSellDetailBank,
          payTypeSellDetailObservations:this.currentPayTypeSellDetail.payTypeSellDetailObservations,
        })

      }

}

fillPayTypeSellDetailsEmpty():void
    {
        this.payTypeSellDetailForm.patchValue({
          payTypeId:1,
          invoiceTypeId:2,
          numberPayTypeSellDetail: null,
          datePayTypeSellDetail: new Date(),

          totalPayTypeSellDetail: 0,
          counterPayTypeSellDetail:null,
          totalPayTypeSellDetailList:null,
          payTypeSellDetailBank:null,
          payTypeSellDetailObservations:null
        })
}



addNewSellDetail():void{

        if(this.showSellDetailNav && !this.showLastSellDetail)
        {
          if(this.sellDetailsList.length>0)
          {
            this.positionCurrentSellDetail=this.sellDetailsList.length;
            this.showSellDetailNav=false;
            this.showLastSellDetail=true;
            this.clearSellDetails();

          }
          else{

            this.clearSellDetails();
            this.positionCurrentSellDetail=0;

            this.showSellDetailNav=true;
            this.showLastSellDetail=false;
          }
        }
        else if(!this.showSellDetailNav && this.showLastSellDetail)
        {

            if(this.sellDetailsList.length>0)
            {
              this.positionCurrentSellDetail=this.sellDetailsList.length-1;
              this.currentSellDetail=this.sellDetailsList[this.positionCurrentSellDetail];

              this.sellDetailsForm.patchValue({
                profesionalId:this.currentSellDetail.profesionalId,
                serviceGroupId:this.currentSellDetail.serviceGroupId,
                serviceTypeId: this.currentSellDetail.serviceTypeId,
                price:this.currentSellDetail.price,
                counterSellDetail:this.positionCurrentSellDetail+1
                })
                let svcGroupId=this.currentSellDetail.serviceGroupId;
                let svcGroupIdString=this.convertNumberToString(svcGroupId);
                this.serviceTypeListShort=Utilities.getServicesxGroupId(svcGroupIdString, this.serviceTypeList);


              this.showSellDetailNav=true;
              this.showLastSellDetail=false;
            }
            else{

              this.positionCurrentSellDetail=0;
              this.showSellDetailNav=false;
              this.showLastSellDetail=false;
              this.clearSellDetails();
            }
          }
          else{
            this.clearSellDetails();
          }

}

addNewPayTypeSellDetail():void
    {

      if(this.showPayTypeSellDetailNav && !this.showLastPayTypeSellDetail)
      {
          if(this.payTypeSellDetailsList.length>0)
          {
            this.positionCurrentPayTypeSellDetail=this.payTypeSellDetailsList.length;
            this.showPayTypeSellDetailNav=false;
            this.showLastPayTypeSellDetail=true;
            this.clearPayTypeSellDetails();

            this.payTypeSellDetailForm.patchValue({
              counterPayTypeSellDetail:this.positionCurrentPayTypeSellDetail,
              totalPayTypeSellDetailList:this.payTypeSellDetailsList.length
            })


          }
          else{
            this.clearPayTypeSellDetails();
            this.positionCurrentPayTypeSellDetail=0;
            this.showPayTypeSellDetailNav=true;
            this.showLastPayTypeSellDetail=false;
          }
          this.showSavePtBtn=true;


      }
      else if(!this.showPayTypeSellDetailNav && this.showLastPayTypeSellDetail)
      {
        if(this.payTypeSellDetailsList.length>0)
        {
          //Formatea fecha
         const opcions={weekday:'long', year:'numeric', month:'short'};

          this.positionCurrentPayTypeSellDetail=this.payTypeSellDetailsList.length-1;
          this.currentPayTypeSellDetail=this.payTypeSellDetailsList[this.positionCurrentPayTypeSellDetail];

          this.payTypeSellDetailForm.patchValue({
            payTypeId:this.currentPayTypeSellDetail.payTypeId,
            numberPayTypeSellDetail:this.currentPayTypeSellDetail.numberPayTypeSellDetail,
            datePayTypeSellDetail:this.currentPayTypeSellDetail.datePayTypeSellDetail,
            totalPayTypeSellDetail:this.currentPayTypeSellDetail.price,
            invoiceTypeId:this.currentPayTypeSellDetail.invoiceTypeId,
            payTypeSellDetailBank:this.currentPayTypeSellDetail.payTypeSellDetailBank,
            payTypeSellDetailObservations:this.currentPayTypeSellDetail.payTypeSellDetailObservations,

          });

          this.showPayTypeSellDetailNav=true;
          this.showLastPayTypeSellDetail=false;

        }
        else{
          this.positionCurrentPayTypeSellDetail=0;
          this.showPayTypeSellDetailNav=true;
          this.showLastPayTypeSellDetail=false;
          this.clearPayTypeSellDetails();
        }
      }
      else
      {
        this.clearPayTypeSellDetails();
      }
}

addNewSubServiceDetail():void
    {

      if(this.showSubServiceDetailNav && !this.showLastSubServiceDetail)
      {
          if(this.subServicesByCurrentSdList.length>0)
          {
            this.positionCurrentSubServiceDetail=this.subServicesByCurrentSdList.length;
            this.showSubServiceDetailNav=false;
            this.showLastSubServiceDetail=true;
            this.clearSubServiceDetail();
          }
          else{
            this.clearSubServiceDetail();
            this.positionCurrentSubServiceDetail=0;
            this.showSubServiceDetailNav=false;
            this.showLastSubServiceDetail=true;
          }

      }
      else  if(!this.showSubServiceDetailNav && this.showLastSubServiceDetail)
      {
        if(this.subServicesByCurrentSdList.length>0)
        {
          //Formatea fecha
         const opcions={weekday:'long', year:'numeric', month:'short'};

         this.positionCurrentSubServiceDetail=this.subServicesByCurrentSdList.length-1;
          this.currentSubServiceDetail=this.subServicesByCurrentSdList[this.positionCurrentSubServiceDetail];

          this.showSubServiceDetailNav=true;
          this.showLastSubServiceDetail=false;
          //
          this.subServiceDetailForm.patchValue({
            subServiceGroupId:   this.currentSubServiceDetail.subServiceGroupId,
            subServiceTypeId:    this.currentSubServiceDetail.subServiceTypeId,
            serviceTypeId:       this.currentSubServiceDetail.serviceTypeId,
            profesionalId:       this.currentSubServiceDetail.profesionalId,
            dateSubService:      this.currentSubServiceDetail.date,
            observations:        this.currentSubServiceDetail.observations,
            price:               this.currentSubServiceDetail.price
          })
        }
        else{
          this.positionCurrentSubServiceDetail=0;
          this.showSubServiceDetailNav=false;
          this.showLastSubServiceDetail=false;
          this.clearSubServiceDetail();
        }
      }
      else
      {
        this.clearSubServiceDetail();
      }

}
//#endregion fill & addNew

//#region clear
clearSellDetails():void
    {
      this.sellDetailsForm.patchValue({
        profesionalId:null,
        serviceTypeId: null,
        serviceGroupId: null,
        price:null,
      })

}

clearPayTypeSellDetails():void
    {
      this.payTypeSellDetailForm.patchValue({
        payTypeId:null,
        invoiceTypeId:null,
        numberPayTypeSellDetail: null,
        datePayTypeSellDetail: null,
        totalPayTypeSellDetail:null,
        counterPayTypeSellDetail:null,
        totalPayTypeSellDetailList:null,
        payTypeSellDetailBank:null,
        payTypeSellDetailObservations:null
      })

}

clearSubServiceDetail():void{

      this.subServiceDetailForm.patchValue({
        subServiceGroupId:   null,
        subServiceTypeId:    null,
        serviceTypeId:       null,
        profesionalId:       null,
        dateSubService:      null,
        price:                null,
        observations:        null,
      })
}

clearGeneralShows():void{
     // this.showSellSavePersonalDataBtn =false;
      this.showSellDetailNav           =false;
      this.showLastSellDetail          =false;
      this.showPayTypeSellDetailNav    =false;
      this.showLastPayTypeSellDetail   =false;
}
//#endregion clear


getPayTypeNamedFromUtilities(payTypeId, data:BOPayType[]):string{
  return Utilities.getPayTypeName(payTypeId, data);
}

close(): void {
  this.clearGeneralShows();
  this.sellForm.reset();
  this.sellDetailsForm.reset();
  this.payTypeSellDetailForm.reset();
  this.subServiceDetailForm.reset();
  this.sellb=null;
  this.sellDetailsList=[];
  this.payTypeSellDetailsList=[];
  this.subServiceDetailList=[];
  this.modal.hide();
  this.closeModal.emit(); // Notifica al componente principal que el modal se cerró
}

onOptionGroupSelected(sended: number)
{

     let service='';
     service=this.convertNumberToString(sended);
     let tempDat:BOItem[]=[];

     for(let i=0;i<this.serviceTypeList.length; i++)
      {
        if (this.serviceTypeList[i].serviceGroup==service)
          {
            tempDat.push(this.serviceTypeList[i]);
          }
      }
      this.serviceTypeListShort=tempDat;
}

// onOptionServiceTypeSelected(sended: number)
// {

//     this._subServiceType.getSubServicesByService(".n").subscribe({
//         next: (data) => {
//             this.subServiceTypeListShort = data;
//             this.filteredSubServicesShort.next(this.subServiceTypeListShort.slice());
//         },
//         error: (err) => {
//             console.error('Error cargando subservicios', err);
//         }
//     });
// }
// onOptionServiceTypeSelected(sended: number) {
//     console.log('🟡 [onOptionServiceTypeSelected] Iniciando. Valor recibido:', sended);

//     this._subServiceType.getSubServicesByService(".n").subscribe({
//         next: (data) => {
//             console.log('✅ [onOptionServiceTypeSelected] Datos recibidos del servicio:', data);
//             console.log('✅ [onOptionServiceTypeSelected] Cantidad de items:', data?.length);

//             this.subServiceTypeListShort = data;
//             this.filteredSubServicesShort.next(this.subServiceTypeListShort.slice());

//             console.log('✅ [onOptionServiceTypeSelected] filteredSubServicesShort emitido con:', this.subServiceTypeListShort.slice());
//         },
//         error: (err) => {
//             console.error('❌ [onOptionServiceTypeSelected] Error en la llamada HTTP:', err);
//         }
//     });

//     console.log('🟡 [onOptionServiceTypeSelected] Llamada HTTP disparada (respuesta aún pendiente)');
// }
onOptionServiceTypeSelected(sended: number) {
    console.log('🟡 [onOptionServiceTypeSelected] Iniciando. Valor recibido:', sended);

    if (!sended) {
        console.warn('⚠️ [onOptionServiceTypeSelected] sended es null/undefined/0. Abortando.');
        return;
    }

    // ✅ Se pasa el ID real del servicio seleccionado
    this._subServiceType.getSubServicesByService(sended.toString()).subscribe({
        next: (data) => {
            console.log('✅ [onOptionServiceTypeSelected] Datos recibidos:', data);
            console.log('✅ [onOptionServiceTypeSelected] Cantidad:', data?.length);

            this.subServiceTypeListShort = data;
            this.filteredSubServicesShort.next(this.subServiceTypeListShort.slice());
        },
        error: (err) => {
            console.error('❌ [onOptionServiceTypeSelected] Error HTTP:', err);
        }
    });
}



onOptionAreaSelected(area: any)
{
 if (area != null)
  {
      this.serviceGroupListShort=[];
      this.profesionalsListShort =[];
      this.serviceGroupListShort=Utilities.getGroupsByAreaId(area, this.serviceGroupList);
      this.profesionalsListShort =Utilities.getProfessionalssByAreaId(area, this.profesionals);
  }
  else{
    this.toastr.error('Error','No se ha seleccionado un área');
  }
}

onOptionProfessionalSelected(event: MatSelectChange)
{
  console.log("En onOptionProfessionalSelected, event es:", event, " y su typo es:", typeof event);
  let professionalId:number= event.value;
   console.log("professionalId es:", professionalId);
 if (professionalId!= null)
  {
      this.subServiceDetailForm.patchValue({
        profesionalId: professionalId,

      });
      this._changeDetectorRef.detectChanges();
  }
  else{
    this.toastr.error('Error','No se ha seleccionado un profesional');
  }
}

//#region clipboard

copyToClipboardAll(): void {

  const userName = this.sellForm.get('userName')?.value;
  const userDocumentId= this.sellForm.get('userId')?.value;
  const userEmail= this.sellForm.get('userEmail')?.value;

  const clipboardContent = `${userName}\n ${userDocumentId}\n ${userEmail}`;

  navigator.clipboard.writeText(clipboardContent).then(() => {
    console.log('Datos copiados al portapapeles:', clipboardContent);
  }).catch((err) => {
    console.error('Error al copiar al portapapeles:', err);
  });
}

copyToClipboardName(): void {
  const userName = this.sellForm.get('userName')?.value;
  const clipboardContent = `${userName}`;

  navigator.clipboard.writeText(clipboardContent).then(() => {

    console.log('Datos copiados al portapapeles:', clipboardContent);
  }).catch((err) => {
    console.error('Error al copiar al portapapeles:', err);
  });
}

copyToClipboardDocument(): void {
  const userDocumentId= this.sellForm.get('userId')?.value;
  const clipboardContent =`${userDocumentId}`;

  navigator.clipboard.writeText(clipboardContent).then(() => {
    console.log('Datos copiados al portapapeles:', clipboardContent);
  }).catch((err) => {
    console.error('Error al copiar al portapapeles:', err);
  });
}

copyToClipboardEmail(): void {
  const userEmail= this.sellForm.get('userEmail')?.value;
  const clipboardContent =`${userEmail}`;
  navigator.clipboard.writeText(clipboardContent).then(() => {
    console.log('Datos copiados al portapapeles:', clipboardContent);
  }).catch((err) => {
    console.error('Error al copiar al portapapeles:', err);
  });
}

//#endregion clipboard


convertNumberToString(target:number):string
  {
    let converted='';

    if(target>=10)
    {
      converted=target.toString().trim();
    }
    else{
      converted='0'+target.toString().trim();
    }

    return converted;
}

addDataToArray(item:any, array:any[] ):any
  {
    array=[...array, item];
    return array;
}

addDateNow(){
  this.sellForm.patchValue({
    dateSell:new Date(),
     });

  this.payTypeSellDetailForm.patchValue({
    datePayTypeSellDetail: new Date(),
  })
}
//#region print

generatePDF() {
  console.log("Entra generatePDF");
  const documentDefinition = this.getDocumentDefinition();
 pdfMake.createPdf(documentDefinition).open();
}

generatePDFBySubService(position:number) {
  const documentDefinition = this.getDocumentDefinitionBySubService(position);
 pdfMake.createPdf(documentDefinition).open();
}

private generateBlob(documentDefinition: any): Promise<Blob> {
  return new Promise((resolve, reject) => {
    pdfMake.createPdf(documentDefinition).getBlob((blob: Blob) => {
      if (blob) {
        resolve(blob);
      } else {
        reject(new Error('No se pudo generar el Blob.'));
      }
    });
  });
}


buildNameFromSellb(x:number):string{
  let result='';
  let nameTemp='';
  let codeInvoice= x;// this.sellb.documentNumber.trim();
  let name=this.sellb.userName.split(' ');

  for (let i=0; i<name.length; i++){
    if(i!=name.length-1)
    {

      nameTemp+=name[i].trim() +'-';
    }
    else{
      nameTemp+=name[i].trim();
    }
  }
  result=codeInvoice +'-'+nameTemp +'.pdf';

  return result;

}


// getDocumentDefinition()
// {
//     console.log("Entra a getDocumentDefinition");
//     console.log("1. En getDocDef, currentSell es:", this.currentSell);
//     console.log("2. En getDocDef, currentSellDetail es:", this.currentSellDetail);
//     console.log(" En getDocDef, this.payTypeSellDetailsList es:", this.payTypeSellDetailsList);


//     let dateTemp=this.datePipe.transform(Date.now(), 'dd /MM/YYYY');

//     let logoshort='data:image/png;base64,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';


//     if(this.currentSellDetail.subServicesDetails.length==0)
//     {

//       this.toastr.error('No hay subservicios para imprimir recibo');
//     }
//     else{

//       return {
//         pageSize: 'A4',
//         pageMargins: [10, 120, 20, 60],

//         header:[
//               {
//                 columns:
//                  [
//                   {
//                     margin: [35, 0, 0, 0],
//                       image: logoshort +',', alignment: 'center', width: 200, height:74,
//                   },
//                   {
//                     fontSize:10,
//                     text:
//                     [
//                       {text:'Calle 5 Oeste Nª D-50-03\n' },
//                       {text:'B/El Cortijo -Cali- Valle-Colombia\n' },
//                       {text:'Telf: 316 4071420\n' },
//                     ],
//                     margin: [15, 25, 0, 0],
//                     width: '30%'
//                   },

//                   {
//                     fontSize: 16,
//                     text: [{ text: 'RECIBO DE CAJA Nº: ',bold: true}, this.currentSell.documentNumber],
//                     margin: [15, 25, 0, 0],
//                     width: '30%'
//                   },
//                 ]
//               },
//               {
//                 fontSize: 10,
//                 columns:
//                  [
//                     {
//                         text: 'NIT ' + this.company.nit,
//                         margin: [35, 0, 0, 0],
//                         width: '50%'
//                     }
//                 ]
//               },
//               {
//                 fontSize: 10,
//                 columns: [
//                     {
//                         text: this.company.email,
//                         width: '40%',
//                         margin: [35, 0, 0,0],
//                         alignment: 'left',


//                     },
//                     {
//                       text:'',
//                        width: '5%',
//                        margin: [15, 0, 0, 5],

//                     },
//                     {
//                       text: 'www.servivitalcentromedico.com.co',
//                       margin: [0, 0, -50, 5],
//                         alignment: 'right',
//                       width: '40%'
//                   },


//                 ]
//               },

//         ],



//         content:
//         [
//           { //obj1

//                 columns:
//                 [

//                   {
//                     fontSize: 10,
//                     table:
//                     {
//                       widths: [103, 103,103,103,103],
//                       body:
//                       [
//                           [ //row 1

//                             {text:[
//                                       {text:'FECHA:\n', bold:true},
//                                       {text: dateTemp}
//                                   ]
//                              },

//                             {

//                               colSpan:3,
//                               text:
//                                   [
//                                       {text:'PROFESIONAL:\n', bold:true },
//                                       {text: this.getProfesionalName(this.currentSellDetail.profesionalId)},

//                                   ]
//                             },
//                             {},
//                             {},
//                             {
//                               fontSize: 12,
//                               text:
//                                   [
//                                     {text:'$:\n', bold:true },
//                                     {text: this.currentSellDetail.price}

//                                   ]
//                             },

//                           ], //end row1

//                           [ //row 2

//                             {
//                               //
//                               colSpan:2,
//                                  text:[
//                                   {text:'PAGADO POR:\n', bold:true},
//                                   {text: this.currentSell.userName}
//                                 ]

//                             },
//                             {},
//                             {
//                               colSpan:2,
//                                  text:[
//                                   {text:'EMAIL:\n', bold:true},
//                                   {text: this.currentSell.userEmail}
//                                  ]
//                             },
//                             {},
//                             {text:
//                               [
//                                 {text:this.idTypeList.find(x => x.id== this.currentSell.idTypeIdentification).code + ':\n', bold:true },
//                                 {text: this.currentSell.userIdString}
//                               ]
//                             },
//                           ], //end row2

//                           [

//                             {
//                               colSpan:5,

//                                   table:
//                                   {
//                                    widths: [200, 200, 115 ],
//                                   body:
//                                   [
//                                     [
//                                       {text: 'SERVICIO', bold: true},
//                                       {text: 'DETALLE (Subservicio)', bold: true},
//                                       {text: 'VALOR', bold: true},

//                                        ...this.currentSellDetail.subServicesDetails.map(sub=>
//                                       (
//                                         [
//                                           sub.serviceName,
//                                           sub.subServiceName,
//                                           sub.price,
//                                         ]

//                                       )),
//                                     ],



//                                   ],
//                                   },
//                                   layout: 'noBorders'
//                             },


//                             {},
//                             {},
//                             {},
//                             {},
//                           ],


//                           [

//                             {
//                               //
//                               colSpan:5,

//                               table:
//                               {
//                                 widths: [515 ],
//                                 body:
//                                 [
//                                   [
//                                     {
//                                       text:[
//                                         {text: 'OBSERVACIONES:\n', bold: true},
//                                         {text: this.currentSell.observations.length>0?this.currentSell.observations:'No'},


//                                       ]
//                                     }

//                                   ],

//                                 ],
//                                 },
//                                 layout: 'noBorders'

//                             },
//                             {},
//                             {},
//                             {},
//                             {},


//                           ],

//                           [

//                             {
//                               //
//                               colSpan:5,

//                               table:
//                               {
//                                 widths: [515 ],
//                                 body:

//                                 [
//                                   [
//                                     {text: 'METODO(S) DE PAGO :', bold: true},
//                                   ],



//                                   // ...this.payTypeSellDetailsList.map(sub=>
//                                   // (

//                                   //   [
//                                   //       `${this.getPayTypeNamedFromUtilities(sub.payTypeId, this.payTypeList)}${sub.payTypeSellDetailBank ? ' - BANCO: ' + sub.payTypeSellDetailBank.toUpperCase() : ''} ${' - VALOR:' +sub.price}`
//                                   //   ]

//                                   // )),

//                                   ...this.payTypeSellDetailsList
//                                   .filter(sub => sub && sub.payTypeId && typeof sub.price !== 'undefined') // Filtrar elementos válidos
//                                   .map(sub => {
//                                     const payTypeName = this.getPayTypeNamedFromUtilities(sub.payTypeId, this.payTypeList);
//                                     if (!payTypeName) {
//                                       return [];
//                                     }
//                                     return [
//                                       `${payTypeName}${sub.payTypeSellDetailBank ? ' - BANCO: ' + sub.payTypeSellDetailBank.toUpperCase() : ''} ${' - VALOR:' + sub.price}`
//                                     ];
//                                   }),

//                                 ],


//                               },// end table




//                                 layout: 'noBorders'

//                             },
//                             {},
//                             {},
//                             {},
//                             {},


//                           ],

//                           [

//                             {
//                               //
//                               colSpan:2,
//                                  text:[
//                                   {text:'VALOR EN LETRAS:\n', bold:true},
//                                   {text: this.transformNumberToText(this.currentSellDetail.price.toString()).toUpperCase() + ' PESOS'}

//                                 ]

//                             },
//                             {},

//                             {
//                               colSpan:3,
//                                  text:[
//                                   {text:'SELLO Y FIRMA:\n\n\n\n\n\n', bold:true},
//                                 ]

//                             },
//                             {},
//                             {},
//                           ],
//                       ],
//                     }
//                   }, //End columns

//                 ]

//           }, //End obj1

//             //neW
//           { text: ' ', margin: [0, 10, 0, 10] },


//             {

//               columns:
//               [

//                   {
//                       fontSize: 10,
//                       table:
//                       {
//                         widths: [196, 170,168],
//                         body:
//                           [
//                              [
//                                 {
//                                   image: logoshort +',', alignment: 'center', width: 200, height:74,

//                                 },
//                                 {
//                                   text:
//                                   [
//                                     {text:'Calle 5 Oeste Nª D-50-03\n' },
//                                     {text:'B/El Cortijo -Cali- Valle-Colombia\n' },
//                                     {text:'Telf: 316 4071420\n' },


//                                   ]
//                                 },
//                                 {
//                                   text:
//                                   [
//                                     {text: `RECIBO DE CAJA Nº: ${this.currentSell.documentNumber}`,bold: true, fontSize:14},
//                                   ],
//                                 }

//                               ]

//                           ]
//                       }
//                   }


//               ]
//             },

//             {
//               columns:
//               [

//                 {
//                   fontSize: 10,
//                   table:
//                   {
//                     widths: [103, 103,103,103,103],
//                     body:
//                     [
//                         [

//                           {text:[
//                                     {text:'FECHA:\n', bold:true},
//                                     {text: dateTemp}
//                                 ]
//                            },

//                           {

//                             colSpan:3,
//                             text:
//                                 [
//                                     {text:'PROFESIONAL:\n', bold:true },
//                                     {text: this.getProfesionalName(this.currentSellDetail.profesionalId)},

//                                 ]
//                           },
//                           {},
//                           {},
//                           {
//                             fontSize: 12,
//                             text:
//                                 [
//                                   {text:'$:\n', bold:true },
//                                   {text: this.currentSellDetail.price}

//                                 ]
//                           },

//                         ],

//                         [

//                           {
//                             //
//                             colSpan:2,
//                                text:[
//                                 {text:'PAGADO POR:\n', bold:true},
//                                 {text: this.currentSell.userName}
//                               ]

//                           },
//                           {},
//                           {
//                             colSpan:2,
//                                text:[
//                                 {text:'EMAIL:\n', bold:true},
//                                 {text: this.currentSell.userEmail}
//                                ]
//                           },
//                           {},
//                           {text:
//                             [
//                               {text:this.idTypeList.find(x => x.id== this.currentSell.idTypeIdentification).code + ':\n', bold:true },
//                               {text: this.currentSell.userIdString}
//                             ]
//                           },
//                         ],

//                         [

//                           {
//                             colSpan:5,

//                                 table:
//                                 {
//                                  widths: [200, 200, 115 ],
//                                 body:
//                                 [
//                                   [
//                                     {text: 'SERVICIO', bold: true},
//                                     {text: 'DETALLE (Subservicio)', bold: true},
//                                     {text: 'VALOR', bold: true},
//                                   ],

//                                     ...this.currentSellDetail.subServicesDetails.map(sub=>
//                                     (
//                                       [
//                                         sub.serviceName,
//                                         sub.subServiceName,
//                                         sub.price,
//                                       ]

//                                     )),

//                                 ],
//                                 },
//                                 layout: 'noBorders'
//                           },


//                           {},
//                           {},
//                           {},
//                           {},
//                         ],

// ////
//                         [

//                           {
//                             //
//                             colSpan:5,

//                             table:
//                               {
//                                widths: [515 ],
//                               body:
//                               [
//                                   [
//                                     {
//                                       text:[
//                                         {text: 'OBSERVACIONES:\n', bold: true},
//                                         {text: this.currentSell.observations.length>0?this.currentSell.observations:'No'},


//                                       ]
//                                     }

//                                   ],


//                               ],
//                               },
//                               layout: 'noBorders'

//                           },
//                           {},
//                           {},
//                           {},
//                           {},
//                         ],

// ////

//                         [

//                           {
//                             colSpan:5,

//                             table:
//                             {
//                               widths: [515 ],
//                               body:

//                               [
//                                 [
//                                   {text: 'METODO(S) DE PAGO :', bold: true},
//                                 ],

//                                 ...this.payTypeSellDetailsList.map(sub=>
//                                 (

//                                   [
//                                       `${this.getPayTypeNamedFromUtilities(sub.payTypeId, this.payTypeList)}${sub.payTypeSellDetailBank ? ' - BANCO: ' + sub.payTypeSellDetailBank.toUpperCase() : ''} ${' - VALOR:' +sub.price}`
//                                   ]

//                                 )),

//                               ],


//                             },// end table

//                             layout: 'noBorders'

//                           },
//                           {},
//                           {},
//                           {},
//                           {},


//                         ],
// ///
//                         [

//                           {
//                             colSpan:2,
//                                text:[
//                                 {text:'VALOR EN LETRAS:\n', bold:true},
//                                 {text: this.transformNumberToText(this.currentSellDetail.price.toString()).toUpperCase() + ' PESOS'}

//                               ]

//                           },
//                           {},

//                           {
//                             colSpan:3,
//                                text:[
//                                 {text:'SELLO Y FIRMA:\n\n\n\n\n\n', bold:true},
//                               ]

//                           },
//                           {},
//                           {},
//                         ],
//                     ],
//                   }
//                 },

//               ]

//             },

//         ],

//         styles: {
//           header: {
//             fontSize: 18,
//             bold: true,
//             margin: [0, 0, 0, 10]
//           },
//           subheader: {
//             fontSize: 16,
//             bold: true,
//             margin: [0, 10, 0, 5]
//           },
//           tableExample: {
//             margin: [0, 5, 0, 15]
//           },
//           tableHeader: {
//             bold: true,
//             fontSize: 13,
//             color: 'black'
//           }
//         },
//         defaultStyle: {
//         }
//       }

//     }


// }

getDocumentDefinition()
{

    let dateTemp=this.datePipe.transform(Date.now(), 'dd /MM/YYYY');

    let logoshort='data:image/png;base64,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';


    if(this.currentSellDetail.subServicesDetails.length==0)
    {

      this.toastr.error('No hay subservicios para imprimir recibo');
    }
    else{

      return {
        pageSize: 'A4',
        pageMargins: [10, 120, 20, 60],

        header:[
              {
                columns:
                 [
                  {
                    margin: [35, 0, 0, 0],
                      image: logoshort +',', alignment: 'center', width: 200, height:74,
                  },
                  {
                    fontSize:10,
                    text:
                    [
                      {text:'Calle 5 Oeste Nª D-50-03\n' },
                      {text:'B/El Cortijo -Cali- Valle-Colombia\n' },
                      {text:'Telf: 316 4071420\n' },
                    ],
                    margin: [15, 25, 0, 0],
                    width: '30%'
                  },

                  {
                    fontSize: 16,
                    text: [{ text: 'RECIBO DE CAJA Nº: ',bold: true}, this.currentSell.documentNumber],
                    margin: [15, 25, 0, 0],
                    width: '30%'
                  },
                ]
              },
              {
                fontSize: 10,
                columns:
                 [
                    {
                        text: 'NIT ' + this.company.nit,
                        margin: [35, 0, 0, 0],
                        width: '50%'
                    }
                ]
              },
              {
                fontSize: 10,
                columns: [
                    {
                        text: this.company.email,
                        width: '40%',
                        margin: [35, 0, 0,0],
                        alignment: 'left',


                    },
                    {
                      text:'',
                       width: '5%',
                       margin: [15, 0, 0, 5],

                    },
                    {
                      text: 'www.servivitalcentromedico.com.co',
                      margin: [0, 0, -50, 5],
                        alignment: 'right',
                      width: '40%'
                  },


                ]
              },

        ],



        content:
        [
          { //obj1

                columns:
                [

                  {
                    fontSize: 10,
                    table:
                    {
                      widths: [103, 103,103,103,103],
                      body:
                      [
                          [ //row 1

                            {text:[
                                      {text:'FECHA:\n', bold:true},
                                      {text: dateTemp}
                                  ]
                             },

                            {

                              colSpan:3,
                              text:
                                  [
                                      {text:'PROFESIONAL:\n', bold:true },
                                      {text: this.getProfesionalName(this.currentSellDetail.profesionalId)},

                                  ]
                            },
                            {},
                            {},
                            {
                              fontSize: 12,
                              text:
                                  [
                                    {text:'$:\n', bold:true },
                                    {text: this.currentSellDetail.price}

                                  ]
                            },

                          ], //end row1

                          [ //row 2

                            {
                              //
                              colSpan:2,
                                 text:[
                                  {text:'PAGADO POR:\n', bold:true},
                                  {text: this.currentSell.userName}
                                ]

                            },
                            {},
                            {
                              colSpan:2,
                                 text:[
                                  {text:'EMAIL:\n', bold:true},
                                  {text: this.currentSell.userEmail}
                                 ]
                            },
                            {},
                            {text:
                              [
                                {text:this.idTypeList.find(x => x.id== this.currentSell.idTypeIdentification).code + ':\n', bold:true },
                                {text: this.currentSell.userIdString}
                              ]
                            },
                          ], //end row2

                          [

                            {
                              colSpan:5,

                                  table:
                                  {
                                   widths: [200, 200, 115],
                                    body:
                                    [
                                      [
                                        {text: 'SERVICIO', bold: true},
                                        {text: 'DETALLE (Subservicio)', bold: true},
                                        {text: 'VALOR', bold: true},
                                      ],
                                        ...this.currentSellDetail.subServicesDetails.map(sub=>
                                        (
                                          [
                                            sub.serviceName,
                                            sub.subServiceName,
                                            sub.price,
                                          ]

                                        ))
                                    ],
                                    },
                                    layout: 'noBorders'
                            },


                            {},
                            {},
                            {},
                            {},
                          ],


                          [

                            {
                              //
                              colSpan:5,

                              table:
                              {
                                widths: [515],
                                body:
                                [
                                  [
                                    {
                                      text:[
                                        {text: 'OBSERVACIONES:\n', bold: true},
                                        {text: this.currentSell.observations.length>0?this.currentSell.observations:'No'},


                                      ]
                                    }

                                  ],

                                ],
                                },
                                layout: 'noBorders'

                            },
                            {},
                            {},
                            {},
                            {},


                          ],

                          [

                            {
                              //
                              colSpan:5,

                              table:
                              {
                                widths: [515],
                                body:

                                [
                                  [
                                    {text: 'METODO(S) DE PAGO :', bold: true},
                                  ],


...this.payTypeSellDetailsList
  .filter(sub => sub && sub.payTypeId && typeof sub.price !== 'undefined')
  .map(sub => {
    const payTypeName = this.getPayTypeNamedFromUtilities(sub.payTypeId, this.payTypeList);

    if (!payTypeName) return null;

    return [
      `${payTypeName}${sub.payTypeSellDetailBank ? ' - BANCO: ' + sub.payTypeSellDetailBank.toUpperCase() : ''} - VALOR: ${sub.price}`
    ];
  })
  .filter(x => x !== null)
                                ],


                              },// end table




                                layout: 'noBorders'

                            },
                            {},
                            {},
                            {},
                            {},


                          ],

                          [

                            {
                              //
                              colSpan:2,
                                 text:[
                                  {text:'VALOR EN LETRAS:\n', bold:true},
                                  {text: this.transformNumberToText(this.currentSellDetail.price.toString()).toUpperCase() + ' PESOS'}

                                ]

                            },
                            {},

                            {
                              colSpan:3,
                                 text:[
                                  {text:'SELLO Y FIRMA:\n\n\n\n\n\n', bold:true},
                                ]

                            },
                            {},
                            {},
                          ],
                      ],
                    }
                  }, //End columns

                ]

          }, //End obj1

//             //neW
          { text: ' ', margin: [0, 10, 0, 10] },


          {

              columns:
              [

                  {
                      fontSize: 10,
                      table:
                      {
                        widths: [196, 170,168],
                        body:
                          [
                             [
                                {
                                  image: logoshort +',', alignment: 'center', width: 200, height:74,

                                },
                                {
                                  text:
                                  [
                                    {text:'Calle 5 Oeste Nª D-50-03\n' },
                                    {text:'B/El Cortijo -Cali- Valle-Colombia\n' },
                                    {text:'Telf: 316 4071420\n' },


                                  ]
                                },
                                {
                                  text:
                                  [
                                    {text: `RECIBO DE CAJA Nº: ${this.currentSell.documentNumber}`,bold: true, fontSize:14},
                                  ],
                                }

                              ]

                          ]
                      }
                  }


              ]
          },

          {
              columns:
              [

                {
                  fontSize: 10,
                  table:
                  {
                    widths: [103, 103,103,103,103],
                    body:
                    [
                        [

                          {text:[
                                    {text:'FECHA:\n', bold:true},
                                    {text: dateTemp}
                                ]
                          },

                          {

                            colSpan:3,
                            text:
                                [
                                    {text:'PROFESIONAL:\n', bold:true },
                                    {text: this.getProfesionalName(this.currentSellDetail.profesionalId)},

                                ]
                          },
                          {},
                          {},
                          {
                            fontSize: 12,
                            text:
                                [
                                  {text:'$:\n', bold:true },
                                  {text: this.currentSellDetail.price}

                                ]
                          },

                        ],

                        [

                          {
                            //
                            colSpan:2,
                               text:[
                                {text:'PAGADO POR:\n', bold:true},
                                {text: this.currentSell.userName}
                              ]

                          },
                          {},
                          {
                            colSpan:2,
                               text:[
                                {text:'EMAIL:\n', bold:true},
                                {text: this.currentSell.userEmail}
                               ]
                          },
                          {},
                          {text:
                            [
                              {text:this.idTypeList.find(x => x.id== this.currentSell.idTypeIdentification).code + ':\n', bold:true },
                              {text: this.currentSell.userIdString}
                            ]
                          },
                        ],

                        [

                          {
                            colSpan:5,

                                table:
                                {
                                 widths: [200, 200, 115],

                                 body: [
                                    [
                                      {text: 'SERVICIO', bold: true},
                                      {text: 'DETALLE (Subservicio)', bold: true},
                                      {text: 'VALOR', bold: true},
                                    ],

                                    ...this.currentSellDetail.subServicesDetails.map(sub => ([
                                      sub.serviceName,
                                      sub.subServiceName,
                                      sub.price,
                                    ]))
                                  ]

                                },
                                layout: 'noBorders'
                          },


                          {},
                          {},
                          {},
                          {},
                        ],

////
                        [

                          {
                            //
                            colSpan:5,

                            table:
                              {
                               widths: [515],
                              body:
                              [
                                  [
                                    {
                                      text:[
                                        {text: 'OBSERVACIONES:\n', bold: true},
                                        {text: this.currentSell.observations.length>0?this.currentSell.observations:'No'},


                                      ]
                                    }

                                  ],


                              ],
                              },
                              layout: 'noBorders'

                          },
                          {},
                          {},
                          {},
                          {},
                        ],

////

                        [

                          {
                            colSpan:5,

                            table:
                            {
                              widths: [515],
                              body:

                              [
                                [
                                  {text: 'METODO(S) DE PAGO :', bold: true},
                                ],

                                ...this.payTypeSellDetailsList.map(sub=>
                                (

                                  [
                                      `${this.getPayTypeNamedFromUtilities(sub.payTypeId, this.payTypeList)}${sub.payTypeSellDetailBank ? ' - BANCO: ' + sub.payTypeSellDetailBank.toUpperCase() : ''} ${' - VALOR:' +sub.price}`
                                  ]

                                )),

                              ],


                            },// end table

                            layout: 'noBorders'

                          },
                          {},
                          {},
                          {},
                          {},


                        ],
///
                        [

                          {
                            colSpan:2,
                               text:[
                                {text:'VALOR EN LETRAS:\n', bold:true},
                                {text: this.transformNumberToText(this.currentSellDetail.price.toString()).toUpperCase() + ' PESOS'}

                              ]

                          },
                          {},

                          {
                            colSpan:3,
                               text:[
                                {text:'SELLO Y FIRMA:\n\n\n\n\n\n', bold:true},
                              ]

                          },
                          {},
                          {},
                        ],
                    ],
                  }
                },

              ]

          },

        ],

        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10]
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5]
          },
          tableExample: {
            margin: [0, 5, 0, 15]
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: 'black'
          }
        },
        defaultStyle: {
        }
      }

    }


}

getDocumentDefinitionBySubService(position:number)
{
    let dateTemp=this.datePipe.transform(Date.now(), 'dd /MM/YYYY');
    let logoshort='data:image/png;base64,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';

    let metodoPagoTexto = '';

// Asegúrate de que haya al menos un elemento
    const subChoosed = this.payTypeSellDetailsList[position];
    if (subChoosed && subChoosed.payTypeId && typeof subChoosed.price !== 'undefined') {
      const payTypeName = this.getPayTypeNamedFromUtilities(subChoosed.payTypeId, this.payTypeList);
      if (payTypeName) {
        metodoPagoTexto = `${payTypeName}${subChoosed.payTypeSellDetailBank ? ' - BANCO: ' + subChoosed.payTypeSellDetailBank.toUpperCase() : ''} - VALOR: ${subChoosed.price}`;
      }

    }

    if(this.currentSellDetail.subServicesDetails.length==0)
    {

      this.toastr.error('No hay subservicios para imprimir recibo');
    }
    else
    {

      return {
        pageSize: 'A4',
        pageMargins: [10, 120, 20, 60],

        header:[
              {
                columns:
                 [
                  {
                    margin: [35, 0, 0, 0],
                      image: logoshort +',', alignment: 'center', width: 200, height:74,
                  },
                  {
                    fontSize:10,
                    text:
                    [
                      {text:'Calle 5 Oeste Nª D-50-03\n' },
                      {text:'B/El Cortijo -Cali- Valle-Colombia\n' },
                      {text:'Telf: 316 4071420\n' },

                    ],
                    margin: [15, 25, 0, 0],
                    width: '30%'
                  },

                  {
                    fontSize: 16,
                    text: [{ text: 'RECIBO DE CAJA Nº: ',bold: true}, this.currentSell.documentNumber],
                    margin: [15, 25, 0, 0],
                    width: '30%'
                  },
                ]
              },
              {
                fontSize: 10,
                columns:
                 [
                    {
                        text: 'NIT ' + this.company.nit,
                        margin: [35, 0, 0, 0],
                        width: '50%'
                    }
                 ]
              },
              {
                fontSize: 10,
                columns: [
                    {
                        text: this.company.email,
                        margin: [35, 0, 0, 5],
                       // width: '50%'
                       width: 200
                    },
                    {
                      text:'FECHA:'+ dateTemp,
                       width: '30%',
                       margin: [15, 0, 0, 5],

                    },
                    {
                      text: 'www.servivitalcentromedico.com.co',
                      margin: [15, 0, 5, 5],
                      alignment: 'left',
                      width: '32%'
                  },


                ]
             },

        ],



        content:
        [

          { //obj1
                columns:
                [

                  {
                    fontSize: 10,
                    table:
                    {
                      widths: [103, 103,103,103,103],
                      body:
                      [

                          [ //row 2

                            {
                              //
                              colSpan:2,
                                 text:[
                                  {text:'SERVICIO :\n', bold:true},
                                  {text: this.currentSellDetail.subServicesDetails[0].serviceName}
                                ]

                            },
                            {},
                            {
                              colSpan:2,
                                 text:[
                                  {text:'PROCEDIMIENTO O SUBSERVICIO:\n', bold:true},
                                  {text: this.currentSellDetail.subServicesDetails[0].subServiceName}
                                 ]
                            },
                            {},
                            {text:
                              [
                                {text:'ABONO:\n', bold:true },
                               {text:'$'+ subChoosed.price, bold: true},
                              ]
                            },
                          ], //end row2

                          [ //row 2

                            {
                              //
                              colSpan:2,
                                 text:[
                                  {text:'PAGADO POR:\n', bold:true},
                                  {text: this.currentSell.userName}
                                ]

                            },
                            {},
                            {
                              colSpan:2,
                                 text:[
                                  {text:'EMAIL:\n', bold:true},
                                  {text: this.currentSell.userEmail}
                                 ]
                            },
                            {},
                            {text:
                              [
                                {text:this.idTypeList.find(x => x.id== this.currentSell.idTypeIdentification).code + ':\n', bold:true },
                                {text: this.currentSell.userIdString}
                              ]
                            },
                          ], //end row2

                          [

                            {
                              //
                              colSpan:5,

                              table:
                              {
                                widths: [515],
                                body:

                                [
                                  [
                                    {text: 'METODO DE PAGO :', bold: true},
                                  ],

                                  [
                                      { text: metodoPagoTexto }
                                  ]
//
                                ],


                              },// end table




                                layout: 'noBorders'

                            },
                            {},
                            {},
                            {},
                            {},


                          ],
                          [

                            {
                              //
                              colSpan:5,

                              table:
                              {
                                widths: [515],
                                body:
                                [
                                  [
                                    {
                                      text:[
                                        {text: 'OBSERVACIONES:\n', bold: true},
                                        // {text: this.currentSell.observations.length>0?this.currentSell.observations:'No'},
                                        {text: this.payTypeSellDetailsList[position].payTypeSellDetailObservations},


                                      ]
                                    }

                                  ],

                                ],
                                },
                                layout: 'noBorders'

                            },
                            {},
                            {},
                            {},
                            {},


                          ],
                          [

                            {
                              //
                              colSpan:2,
                                 text:[
                                  {text:'VALOR EN LETRAS:\n', bold:true},
                         //         {text: this.transformNumberToText(this.currentSellDetail.price.toString()).toUpperCase() + ' PESOS'}
                                  {text: this.transformNumberToText(subChoosed.price.toString()).toUpperCase() + ' PESOS'}

                                ]

                            },
                            {},

                            {
                              colSpan:3,
                                 text:[
                                  {text:'SELLO Y FIRMA:\n\n\n\n\n\n', bold:true},
                                ]

                            },
                            {},
                            {},
                          ],
                      ],
                    }
                  }, //End columns

                ]

          }, //End obj1

            //blank separator
          { text: ' ', margin: [0, 10, 0, 10] },
           // second invoice -header

          {
            canvas: [
              {
                type: 'line',
                x1: 0, y1: 0,
                x2: 515, y2: 0,
                lineWidth: 1,
                lineColor: '#444444',
                dash: { length: 4, space: 2 } // línea discontinua tipo ----
              }
            ],
            margin: [10, 10, 10, 10] // margen alrededor de la línea
          },
          {
                columns:
                 [
                  {
                    margin: [35, 0, 0, 0],
                      image: logoshort +',', alignment: 'center', width: 200, height:74,
                  },
                  {
                    fontSize:10,
                    text:
                    [
                      {text:'Calle 5 Oeste Nª D-50-03\n' },
                      {text:'B/El Cortijo -Cali- Valle-Colombia\n' },
                      {text:'Telf: 316 4071420\n' },

                    ],
                    margin: [15, 25, 0, 0],
                    width: '30%'
                  },

                  {
                    fontSize: 16,
                    text: [{ text: 'RECIBO DE CAJA Nº: ',bold: true}, this.currentSell.documentNumber],
                    margin: [15, 25, 0, 0],
                    width: '30%'
                  },
                ]
          },

          {
                  fontSize: 10,
                  columns:
                  [
                      {
                          text: 'NIT ' + this.company.nit,
                          margin: [35, 0, 0, 0],
                          width: '50%'
                        }
                  ]
          },
          {
                  fontSize: 10,
                  columns: [
                      {
                          text: this.company.email,
                          margin: [35, 0, 0, 5],
                        // width: '50%'
                        width: 200
                      },
                      {
                        text:'FECHA:'+ dateTemp,
                        width: '30%',
                        margin: [15, 0, 0, 5],

                      },
                      {
                        text: 'www.servivitalcentromedico.com.co',
                        margin: [15, 0, 5, 5],
                        alignment: 'left',
                        width: '32%'
                    },


                  ]
          },
          //second invoice: content
          { //obj1 second invoice
                columns:
                [

                  {
                    fontSize: 10,
                    table:
                    {
                      widths: [103, 103,103,103,103],
                      body:
                      [

                          [ //row 2

                            {
                              //
                              colSpan:2,
                                 text:[
                                  {text:'SERVICIO :\n', bold:true},
                                  {text: this.currentSellDetail.subServicesDetails[0].serviceName}
                                ]

                            },
                            {},
                            {
                              colSpan:2,
                                 text:[
                                  {text:'PROCEDIMIENTO O SUBSERVICIO:\n', bold:true},
                                  {text: this.currentSellDetail.subServicesDetails[0].subServiceName}
                                 ]
                            },
                            {},
                            {text:
                              [
                                {text:'ABONO:\n', bold:true },
                               {text:'$'+ subChoosed.price, bold: true},
                              ]
                            },
                          ], //end row2

                          [ //row 2

                            {
                              //
                              colSpan:2,
                                 text:[
                                  {text:'PAGADO POR:\n', bold:true},
                                  {text: this.currentSell.userName}
                                ]

                            },
                            {},
                            {
                              colSpan:2,
                                 text:[
                                  {text:'EMAIL:\n', bold:true},
                                  {text: this.currentSell.userEmail}
                                 ]
                            },
                            {},
                            {text:
                              [
                                {text:this.idTypeList.find(x => x.id== this.currentSell.idTypeIdentification).code + ':\n', bold:true },
                                {text: this.currentSell.userIdString}
                              ]
                            },
                          ], //end row2

                          [

                            {
                              //
                              colSpan:5,

                              table:
                              {
                                widths: [515],
                                body:

                                [
                                  [
                                    {text: 'METODO DE PAGO :', bold: true},
                                  ],

                                  [
                                      { text: metodoPagoTexto }
                                  ]
//
                                ],


                              },// end table




                                layout: 'noBorders'

                            },
                            {},
                            {},
                            {},
                            {},


                          ],
                          [

                            {
                              //
                              colSpan:5,

                              table:
                              {
                                widths: [515],
                                body:
                                [
                                  [
                                    {
                                      text:[
                                        {text: 'OBSERVACIONES:\n', bold: true},
                                        // {text: this.currentSell.observations.length>0?this.currentSell.observations:'No'},
                                        {text: this.payTypeSellDetailsList[position].payTypeSellDetailObservations},
                                      ]
                                    }

                                  ],

                                ],
                                },
                                layout: 'noBorders'

                            },
                            {},
                            {},
                            {},
                            {},


                          ],
                          [

                            {
                              //
                              colSpan:2,
                                 text:[
                                  {text:'VALOR EN LETRAS:\n', bold:true},
                         //         {text: this.transformNumberToText(this.currentSellDetail.price.toString()).toUpperCase() + ' PESOS'}
                                  {text: this.transformNumberToText(subChoosed.price.toString()).toUpperCase() + ' PESOS'}

                                ]

                            },
                            {},

                            {
                              colSpan:3,
                                 text:[
                                  {text:'SELLO Y FIRMA:\n\n\n\n\n\n', bold:true},
                                ]

                            },
                            {},
                            {},
                          ],
                      ],
                    }
                  }, //End columns

                ]

          }, //End obj1

        ],
       //End content

        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10]
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5]
          },
          tableExample: {
            margin: [0, 5, 0, 15]
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: 'black'
          }
        },
        defaultStyle: {
        }
      }

    }


}

getBase64ImageFromURL(url) {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.setAttribute("crossOrigin", "anonymous");

    img.onload = () => {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      var dataURL = canvas.toDataURL("image/png");

      resolve(dataURL);
    };

    img.onerror = error => {
      reject(error);
    };

    img.src = url;
  });
}


readAsDataURL = async (url) => {

    const response = await fetch(url);

    const blob = await response.blob();

    return new Promise((resolve, reject) => {

    let fileReader = new FileReader();

    fileReader.onload = function () {

    return resolve(fileReader.result);

    };

    fileReader.readAsDataURL(blob);

    });

}
//#endregion

//#region transform number to data

transformNumberToText(target:string) {

  if (target.length === 1) {
      return this.getUnits(target);
  }
  if (target.length === 2) {
      return this.getTens(target);
  }
  if (target.length === 3) {
      return this.getHundreds(target);
  }
  if (target.length >=4 && target.length < 7) {
      return this.getThousands(target);
  }
  if (target.length >=7 && target.length < 13) {
      return this.getPeriod(target, 6, 'millón');
  }
  if (target.length >=13 && target.length < 19) {
      return this.getPeriod(target, 12, 'billón');
  }
  return 'Número demasiado grande.';
}

getUnits(target) {
  let numberInt = parseInt(target);
  return this.units[numberInt];
}

getTens(target)
{
  let targetInt = parseInt(target);

  // Obtener las unidades
  let units = target.charAt(1);
  let unitsToInt=parseInt(units);

  let posiToInt=parseInt(target.charAt(0));


  if(targetInt==0)
  {
    return '';
  }

  if(targetInt >=1 && targetInt <10){
   // return     ' ' + this.getUnits(units).replace('uno', 'un'); }

   let data=this.getUnits(units).replace('uno', 'un');
    return  this.getUnits(units).replace('uno', 'un'); }


  if (targetInt >=10 && targetInt < 17)
  {
      return this.tenToSixteen[targetInt - 10];
  }
  if (targetInt < 20) {
      return 'dieci' + this.getUnits(units);
  }

  switch (target) {
      case '20':
          return 'veinte';
      case '22':
          return 'veintidós';
      case '23':
          return 'veintitrés';
      case '26':
          return 'veintiséis';
  }

 if (targetInt < 30) {
      return 'veinti' + this.getUnits(units);
  }

  if(targetInt ==30)
    return 'treinta '+this.getUnits(units);

  if(targetInt<40 && targetInt >=31){
    return 'treinta y '+ this.getUnits(units);
  }

  if(targetInt ==40)
    return 'cuarenta '+this.getUnits(units);

  if(targetInt<50 && targetInt >=41){
    return 'cuarenta y '+ this.getUnits(units);
  }

  if(targetInt ==50)
    return 'cincuenta '+this.getUnits(units);

  if(targetInt<60 && targetInt >=51){
    return 'cincuenta y '+ this.getUnits(units);
  }

  if(targetInt ==60)
    return 'sesenta '+this.getUnits(units);

  if(targetInt<70 && targetInt >=61){
    return 'sesenta y '+ this.getUnits(units);
  }
  if(targetInt ==70)
    return 'setenta '+this.getUnits(units);


  if(targetInt<80 && targetInt >=71){
    return 'setenta y '+ this.getUnits(units);
  }

  if(targetInt ==90)
    return 'noventa '+this.getUnits(units);

  if(targetInt<90 && targetInt >=81){
    return 'ochenta y '+ this.getUnits(units);
  }

  if(targetInt<100 && targetInt >=91){
    return 'noventa y '+ this.getUnits(units);
  }
  let name=this.tens[posiToInt-3];

  if (unitsToInt > 0){
  }

  return name;
}

getHundreds(target) {
  let name = '';
  // Obtener las centenas
  let hundreds = target.charAt(0);

  // Obtener las decenas y unidades
  let tens = parseInt(target.substr(1,1));
  let tensString = target.substr(1);

  let units= parseInt(target.substr(2));
  let unitsString=target.substr(2);

  if (target == 100) {
      return 'cien';
  }
  // Nombres especiales
  switch(hundreds) {
    case '0':
      name = '';
      break;

      case '1':
          name = 'ciento';
          break;
          //
      case '2':
          name = 'pass';
          break;

      case '3':
          name = 'pass';
          break;

      case '4':
          name = 'pass';
            break;
  //

      case '5':
          name = 'quinientos';
          break;

//
      case '6':
        name = 'pass';
        break;
//

      case '7':
          name = 'setecientos';
          break;
//
      case '8':
        name = 'pass';
        break;
//

      case '9':
          name = 'novecientos';
  }
  if (name == 'pass') {
      name = this.getUnits(hundreds) + 'cientos';
  }

  if (tens > 0) {

      name += ' ' + this.transformNumberToText(tensString);

  }

  else{

   name+=' '+this.transformNumberToText(unitsString);

  }

  return name;
}

getThousands(target) {
  let name = 'mil';
  // Obtener cuantos dígitos están en los miles
  let thousandsLength = target.length - 3;
  // Obtener los miles
  let thousands = parseInt(target.substr(0, thousandsLength));
  let thousandsString= target.substr(0, thousandsLength);
  // Obtener las centenas, decenas y unidades
  let hundreds = parseInt(target.substr(thousandsLength));
  let hundredsString = target.substr(thousandsLength);

  if (thousands > 0) {
      // Se reemplaza la palabra uno por un en numeros como 21000, 31000, 41000, etc.
      name = this.transformNumberToText(thousandsString).replace('uno', 'un') + ' mil';
     // name = this.transformNumberToText(thousands) + ' mil';

  }
  if (hundreds > 0) {

    if(thousands>0){
      name += ' ' + this.transformNumberToText(hundredsString);

    }
    else{
      name =  this.transformNumberToText(hundredsString);

    }


  }
  else{
    name=name.trimRight();
    name +=this.transformNumberToText(hundredsString);

  }
  return name;
}

// Obtiene periodos, por ejemplo: millones, billones, etc.
getPeriod(target, digitsToTheRight, periodName) {
  let name = 'un ' + periodName;
  // Obtener cuantos dígitos están dentro del periodo
  let periodLength = target.length - digitsToTheRight;
  // Obtener los dítos del periodo
  let periodDigits = parseInt(target.substr(0, periodLength));
  let periodDigitsString=target.substr(0, periodLength);

  // Obtener los digitos previos al periodo
  let previousDigits = parseInt(target.substr(periodLength));
  let previousDigitsString = target.substr(periodLength);


  if (periodDigits > 1) {

      name = this.transformNumberToText(periodDigitsString).replace('uno', 'un') + ' ' + periodName.replace('ó', 'o') + 'es';
    }
  if (previousDigits > 0) {

      name += ' ' + this.transformNumberToText(previousDigitsString);

  }
  return name;
}

//#endregion transform number to text
setAllbtnsSaveOn(){
  this.showSellDetailSaveBtn=true;
  this.showSaveSbvcBtn=true;
  this.showSavePtBtn=true;
  this.showSellSavePersonalDataBtn=true;
  this.showSaveSellButton=true;
  this._changeDetectorRef.detectChanges()
};



isSameRow(dataRow: any, compareRow: any): boolean {
  // Compara alguna propiedad única (como un ID) para identificar la misma fila
  return dataRow === compareRow;
}
copyTotalSell():void{
  this.payTypeSellDetailForm.patchValue({
    totalPayTypeSellDetail: this.sellForm.get('total').value,
  }

  )

}


resetSave(){
  this.isSaving=false;
}

ngOnDestroy(): void
{
  this.busy?.unsubscribe();
  this.busyData$?.unsubscribe();
}

}
